
// ══════════════════════════════════════════
// CONFIG
// ══════════════════════════════════════════
// Remplace par tes vraies URLs Shopify CDN quand disponibles
const PRODUCT_IMAGES = {
  biberon:   'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/Design_sans_titre_29.png?v=1775448145',
  portecles: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cles-rose.webp?v=1775014619',
  chouchou:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-noir_1.webp?v=1775028673'
};

const LOGO_LONG = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/logo_mysafecup_sans_fond.webp?v=1774866613';
const LOGO_OF   = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/logo_rond_msc.webp?v=1775013720';
const LOGO_ROND = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/logo_rond_msc.webp?v=1775013720';
const LOGO_MAIN = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/logo_mysafecup_sans_fond.webp?v=1774866613';

const SHOPIFY_URLS = {
  biberon:   'https://mysafecup.co/products/safe-cup-biberon',
  portecles: 'https://mysafecup.co/products/safe-cup-porte-cles',
  chouchou:  'https://mysafecup.co/products/safe-cup-chouchou'
};
// ── Vues du dessus pour chouchou & porte-clés (par couleur) ──
const TOP_VIEWS = {
  noir:      'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vu_du_dessus_5.webp?v=1774861560',
  blanc:     'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vu_du_dessus_4.webp?v=1774861557',
  turquoise: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vu_du_dessus_3.webp?v=1774861556',
  gris:      'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vue_du_dessus_gris.webp?v=1774866012',
  biberon_top: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vu_du_dessus_1.webp?v=1774861551',
  rose:      'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/MSC_vue_du_dessus_rose.webp?v=1774861562'
};
// ── Helper : charge une image via fetch→blob (évite le taint CORS du canvas) ──
function loadImgBlob(src, onload){
  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function(){ onload(img); };
  img.onerror = function(){ var img2=new Image(); img2.onload=function(){onload(img2);}; img2.src=src; };
  img.src = src;
}

// Preload top view images
const _topViewImgs = {};
(function(){
  Object.entries(TOP_VIEWS).forEach(([k,src])=>{
    loadImgBlob(src, img=>{
      _topViewImgs[k]=img;
      if(typeof S!=='undefined' && S.step>=3) draw();
    });
  });
})();
// Map couleur selection → top view key
function getTopViewKey(colorName, colorHex){
  if(S.product==='biberon') return 'biberon_top';
  if(colorName==='Noir'||colorHex==='#1A1A1A') return 'noir';
  if(colorName==='Blanc'||colorHex==='#FFFFFF') return 'blanc';
  if(colorName==='Bleu'||colorHex==='#3B9EBF') return 'turquoise';
  if(colorName==='Rose'||colorHex==='#FF6B9D') return 'rose';
  return 'noir';
}
// ── Vues porte-clés par couleur (étape 2) ──
const PORTECLES_VIEWS = {
  noir: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cle-antidrogue-Noir.webp?v=1768905623',
  blanc: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cle-antidrogue-Blanc.webp?v=1768905623',
  turquoise: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cle-antidrogue-Bleu.webp?v=1768905623',
  rose: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cle-antidrogue-Rose_d61189fd-35ae-44ab-bb80-539dc71ef54b.webp?v=1768905623'
};
const _pcViewImgs = {};
(function(){
  Object.entries(PORTECLES_VIEWS).forEach(([k,src])=>{
    loadImgBlob(src, img=>{
      _pcViewImgs[k]=img;
      if(typeof S!=='undefined' && S.product==='portecles') draw();
    });
  });
})();

// ── Vues chouchou par couleur (étape 2) ──
const CHOUCHOU_VIEWS = {
  noir:      'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-noir_1.webp?v=1775028673',
  blanc:     'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-blanc.webp?v=1775028669',
  turquoise: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-bleu.webp?v=1775028677',
  rose:      'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-rose.webp?v=1775028671'
};
const _chViewImgs = {};
(function(){
  Object.entries(CHOUCHOU_VIEWS).forEach(([k,src])=>{
    loadImgBlob(src, img=>{
      _chViewImgs[k]=img;
      if(typeof S!=='undefined' && S.product==='chouchou') draw();
    });
  });
})();

// ── GIF URLs — remplace par les URLs Shopify CDN après upload ──
// Admin Shopify → Contenu → Fichiers → Ajouter des fichiers
// Image résumé sans personnalisation
const SUMMARY_IMG_URL = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/Design_sans_titre_29.png?v=1775448145';
const KRAFT_IMG_URL = 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/biberon-mysafecup-packaging-kraft.webp?v=1774939288';
let _kraftImgLoaded = null;
loadImgBlob(KRAFT_IMG_URL, img=>{ _kraftImgLoaded=img; if(typeof draw==='function') draw(); });

let _summaryImgLoaded = null;
loadImgBlob(SUMMARY_IMG_URL, img=>{ _summaryImgLoaded=img; });

const GIF_URLS = {
  biberon:   'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/BIBERONGIF_78e06c67-77a1-4b5d-83ef-d6af362ff794.gif?v=1741163686',
  portecles: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/PCGIF.gif?v=1768905623',
  chouchou:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchougif_04517543-805a-46f4-baef-2175e5446393.gif?v=1768646535'
};
const PROMO_CODES = { MSC10: 0.10 };

// ── Config Brevo ──
const BREVO_API_KEY  = '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';
const BREVO_SENDER   = {name:'My Safe Cup Configurateur', email:'mathis.grauliere@mysafecup.co'};
const BREVO_TO       = [{email:'mathis.grauliere@mysafecup.co', name:'Mathis Grauliere'}];

async function sendBrevoEmailTo(subject, htmlContent, to, attachments=[]){
  try{
    const body = {sender:BREVO_SENDER, to, subject, htmlContent};
    if(attachments.length) body.attachment = attachments;
    const res = await fetch('https://api.brevo.com/v3/smtp/email', {
      method:'POST',
      headers:{'Content-Type':'application/json','api-key':BREVO_API_KEY},
      body: JSON.stringify(body)
    });
    const d = await res.json();
    if(!res.ok) throw new Error(d.message||'Brevo error '+res.status);
    console.log('Brevo client email OK:', JSON.stringify(d));
    return true;
  }catch(e){ console.error('Brevo client email error:',e); return false; }
}

async function addBrevoContact(ci, devisNum, totalHT){
  try{
    const body = {
      email: ci.mail,
      attributes: {
        PRENOM: ci.pre,
        NOM: ci.nom,
        SMS: ci.tel,
        SOCIETE: ci.soc||'',
        DEVIS_REF: devisNum,
        DEVIS_MONTANT: totalHT,
        DEVIS_PRODUIT: (window.PNAMES||{})[S.product]||S.product,
        DEVIS_QTE: String(S.qty),
        DEVIS_DATE: new Date().toISOString().slice(0,10),
        EVENT_DATE: ci.date||'',
        EVENT_TYPE: ci.type||''
      },
      listIds: [7],
      updateEnabled: true
    };
    const res = await fetch('https://api.brevo.com/v3/contacts', {
      method:'POST',
      headers:{'Content-Type':'application/json','api-key':BREVO_API_KEY},
      body: JSON.stringify(body)
    });
    const d = await res.json();
    console.log('Brevo contact:', JSON.stringify(d));
    return true;
  }catch(e){ console.error('Brevo contact error:',e); return false; }
}

function buildClientEmail(devisNum, ci, totalHT, totalTTC){
  const totalCentimes = Math.round(parseFloat(totalTTC) * 100);
  const cartUrl = `https://mysafecup.co/cart/${SHOPIFY_VARIANT_ID}:${totalCentimes}`;
  const payLink = `https://mysafecup.co/pages/commande-b2b?ref=${encodeURIComponent(devisNum)}&ht=${encodeURIComponent(totalHT)}&ttc=${encodeURIComponent(totalTTC)}&perso=${S.perso||S.collierPerso?'1':'0'}&cart=${encodeURIComponent(cartUrl)}${ci.pre?'&contact='+encodeURIComponent(ci.pre+' '+ci.nom):''}${ci.soc?'&soc='+encodeURIComponent(ci.soc):''}`;
  const isPerso = S.perso || S.collierPerso;
  const prodName = (window.PNAMES||{})[S.product]||S.product;

  // Variantes selon personnalisation ou non
  const heroEmoji = isPerso ? '🎨' : '📋';
  const heroTitle = isPerso ? 'Votre devis personnalisé est prêt !' : 'Votre devis est prêt !';
  const heroSub = isPerso
    ? `Bonjour <strong>${ci.pre}</strong>, voici votre devis <strong>${devisNum}</strong> pour <strong>${ci.soc||'votre organisation'}</strong>. Vos protections seront personnalisées à votre image — le devis complet est joint en pièce jointe.`
    : `Bonjour <strong>${ci.pre}</strong>, voici votre devis <strong>${devisNum}</strong> pour <strong>${ci.soc||'votre organisation'}</strong>. Il est joint en pièce jointe au format PDF.`;
  const messageText = isPerso
    ? `Merci pour votre confiance, et félicitations pour votre initiative — des protections à votre image, c'est encore plus fort pour marquer les esprits et sensibiliser vos convives.<br><br><strong>Vous avez choisi la personnalisation : un design à valider va vous être envoyé avant le lancement en production.</strong><br><br>Notre équipe prend en charge la création de votre visuel et vous soumettra un bon à tirer avant toute production. Nous restons disponibles à chaque étape pour vous accompagner.`
    : `Merci pour votre confiance, et félicitations pour votre initiative — protéger vos convives fait vraiment la différence.<br><br>Nous serions ravis de vous accompagner dans ce projet et restons entièrement disponibles pour répondre à vos questions, affiner votre commande ou vous guider dans le choix des options.`;
  const delaiPerso = isPerso
    ? `<div style="margin-top:10px;background:#E8FBF6;border-radius:6px;padding:8px 10px;font-size:.75rem;color:#1A7A5E"><strong>⏱ Délai de livraison :</strong> 15 à 20 jours ouvrés après validation du bon à tirer.</div>`
    : `<div style="margin-top:10px;background:#E8FBF6;border-radius:6px;padding:8px 10px;font-size:.75rem;color:#1A7A5E"><strong>⚡ Délai de livraison :</strong> 2 à 3 jours ouvrés — expédition sur stock.</div>`;
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head>
<body style="margin:0;padding:0;background:#F9F7F4;font-family:'DM Sans',Arial,sans-serif">
<table width="100%" cellpadding="0" cellspacing="0" style="background:#F9F7F4;padding:32px 16px">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:20px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,.08)">

  <!-- Header -->
  <tr><td style="background:#FDF8E6;padding:28px 40px;text-align:center;border-bottom:1px solid #EDE9D8">
    <img src="https://cdn.shopify.com/s/files/1/0568/7551/6071/files/logo_mysafecup_sans_fond.webp?v=1774866613" height="36" alt="My Safe Cup" style="height:36px">
  </td></tr>

  <!-- Hero -->
  <tr><td style="padding:36px 40px 24px;text-align:center;border-bottom:1px solid #F0EDE8">
    <div style="font-size:2rem;margin-bottom:8px">${heroEmoji}</div>
    <h1 style="font-family:'Bricolage Grotesque',Arial,sans-serif;font-size:1.5rem;font-weight:800;color:#1A1A2E;margin:0 0 8px">${heroTitle}</h1>
    <p style="font-size:.95rem;color:#666;margin:0">${heroSub}</p>
  </td></tr>

  <!-- Message chaleureux -->
  <tr><td style="padding:28px 40px;border-bottom:1px solid #F0EDE8">
    <p style="font-size:.95rem;color:#333;line-height:1.7;margin:0 0 16px">${messageText}</p>
    <table cellpadding="0" cellspacing="0">
      <tr>
        <td style="padding:0 8px 0 0">
          <a href="mailto:contact@mysafecup.co" style="display:inline-block;background:#1A1A2E;color:#fff;text-decoration:none;border-radius:100px;padding:9px 16px;font-size:.78rem;font-weight:700">contact@mysafecup.co</a>
        </td>
        <td>
          <a href="https://wa.me/33659383028" style="display:inline-block;background:#25D366;color:#fff;text-decoration:none;border-radius:100px;padding:9px 16px;font-size:.78rem;font-weight:700">💬 WhatsApp</a>
        </td>
      </tr>
    </table>
  </td></tr>

  <!-- Moyens de paiement -->
  <tr><td style="padding:28px 40px;border-bottom:1px solid #F0EDE8;background:#FEFCF9">
    <h2 style="font-family:'Bricolage Grotesque',Arial,sans-serif;font-size:1rem;font-weight:800;color:#1A1A2E;margin:0 0 16px;text-transform:uppercase;letter-spacing:.5px">Finaliser votre commande</h2>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="48%" style="background:#fff;border:1.5px solid #FF4D6D;border-radius:12px;padding:16px;vertical-align:top">
          <div style="font-size:1.4rem;margin-bottom:8px">💳</div>
          <div style="font-weight:700;font-size:.88rem;color:#1A1A2E;margin-bottom:4px">Carte bancaire — Recommandé</div>
          <div style="font-size:.78rem;color:#555;line-height:1.6;margin-bottom:12px">Finalisez votre paiement en ligne directement sur notre site sécurisé. Votre commande est traitée <strong>instantanément</strong> dès réception du paiement.</div>
          <a href="${payLink}" style="display:block;background:#FF4D6D;color:#fff;text-decoration:none;border-radius:8px;padding:10px 12px;text-align:center;font-size:.82rem;font-weight:700">Confirmer et payer en ligne →</a>
        </td>
        </td>
        <td width="4%"></td>
        <td width="48%" style="background:#fff;border:1.5px solid #E5E2DA;border-radius:12px;padding:16px;vertical-align:top">
          <div style="font-size:1.4rem;margin-bottom:8px">🏦</div>
          <div style="font-weight:700;font-size:.88rem;color:#1A1A2E;margin-bottom:8px">Virement bancaire</div>
          <div style="font-size:.75rem;color:#666;line-height:1.8">
            <div><strong style="color:#1A1A2E">Bénéficiaire :</strong> My Safe Cup</div>
            <div><strong style="color:#1A1A2E">IBAN :</strong> FR76 1910 6000 0844 7096 1576 686</div>
            <div><strong style="color:#1A1A2E">BIC :</strong> AGRIFRPP891</div>
            <div><strong style="color:#1A1A2E">Banque :</strong> Crédit Agricole</div>
            <div style="margin-top:6px;background:#FFF3CD;border-radius:6px;padding:6px 8px"><strong style="color:#856404">Réf. obligatoire :</strong> <span style="color:#856404;font-weight:700">${devisNum}</span></div>
          </div>
        </td>
      </tr>
    </table>
  </td></tr>

  <!-- À propos MSC -->
  <tr><td style="padding:28px 40px;border-bottom:1px solid #F0EDE8">
    <h2 style="font-family:'Bricolage Grotesque',Arial,sans-serif;font-size:1rem;font-weight:800;color:#1A1A2E;margin:0 0 12px;text-transform:uppercase;letter-spacing:.5px">My Safe Cup — Qui sommes-nous ?</h2>
    <p style="font-size:.88rem;color:#555;line-height:1.6;margin:0">My Safe Cup est la marque française de référence en protection anti-soumission chimique. Depuis 2021, nous avons accompagné <strong>+500 clients professionnels</strong> et distribué <strong>+500 000 protections</strong> dans toute l'Europe.</p>
  </td></tr>

  <!-- Footer -->
  <tr><td style="padding:20px 40px;text-align:center;background:#F9F7F4">
    <p style="font-size:.72rem;color:#aaa;margin:0">My Safe Cup · 386 Quai Marcel Pagnol · 83000 Toulon · <a href="https://mysafecup.co" style="color:#aaa">mysafecup.co</a></p>
  </td></tr>

</table>
</td></tr>
</table>
</body></html>`;
}



async function sendBrevoEmail(subject, htmlContent, attachments=[]){
  try{
    const body = {sender:BREVO_SENDER, to:BREVO_TO, subject, htmlContent};
    if(attachments.length) body.attachment = attachments;
    const res = await fetch('https://api.brevo.com/v3/smtp/email', {
      method:'POST',
      headers:{'Content-Type':'application/json','api-key':BREVO_API_KEY},
      body: JSON.stringify(body)
    });
    const d = await res.json();
    if(!res.ok){ 
      console.error('Brevo API error:', res.status, JSON.stringify(d));
      throw new Error(d.message||'Brevo error '+res.status); 
    }
    console.log('Brevo OK:', JSON.stringify(d));
    return true;
  }catch(e){ console.error('Brevo catch error:',e); return false; }
}

const SHOPIFY_VARIANT_ID  = '53404388163923';
const CLOUDINARY_CLOUD    = 'dqjcuyteq';
const CLOUDINARY_PRESET   = 'mysafecup';

async function uploadToCloudinary(file, publicIdPrefix){
  const fd = new FormData();
  fd.append('file', file);
  fd.append('upload_preset', CLOUDINARY_PRESET);
  fd.append('folder', 'msc-logos');
  fd.append('public_id', publicIdPrefix + '_' + Date.now());
  try {
    const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/auto/upload`, {
      method: 'POST', body: fd
    });
    const data = await res.json();
    return data.secure_url || null;
  } catch(e) {
    console.error('Cloudinary upload error:', e);
    return null;
  }
}

// ══════════════════════════════════════════
// STATE
// ══════════════════════════════════════════
const S = {
  step:1, product:'biberon', perso:false,
  color:'transparent', colorName:'Transparent', customColor:false,
  qty:500, logoImg:null, logoFile:null,
  logoCloudUrl:null,
  collierColor:'#1A1A1A', collierCustomColor:false,
  designerFilesMain:[], designerFilesMainUrls:[],
  designerFilesCollier:[], designerFilesCollierUrls:[],
  lx:250, ly:250, lsize:60, lopac:100,
  promo:null, promoDisc:0
};

// Référence de commande partagée entre PDF et Shopify
function genCommandeRef(){
  return 'MSC-'+new Date().getFullYear()+'-'+Date.now().toString().slice(-5);
}
// Stockée globalement à la première génération
let _commandeRef = null;
function getCommandeRef(){ if(!_commandeRef) _commandeRef=genCommandeRef(); return _commandeRef; }
function resetCommandeRef(){ _commandeRef=null; }

// Calcul du total complet (produit + toutes options + extras - remise)
function calcTotalHT(){
  const up=getUnitPrice(), q=S.qty;
  // Remise uniquement sur le produit principal
  const prodCost = up*q;
  const disc = S.promoDisc ? prodCost*S.promoDisc : 0;
  const prodNet = prodCost - disc;
  // Extras sans remise
  const customColorCost=S.customColor?q*0.10:0;
  const multiColorCost=S.multiColor?q*0.05:0;
  let extrasCost=0;
  if(S.extras.collier&&S.extras.qtyCollier){extrasCost+=S.extras.qtyCollier*getCollierBasePrice(S.extras.qtyCollier);}
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){extrasCost+=S.extras.qtyPaillesCarton*getPaillesCartonPrice(S.extras.qtyPaillesCarton);}
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){extrasCost+=S.extras.qtyPaillesInox*getPaillesInoxPrice(S.extras.qtyPaillesInox);}
  ['comptoir','tournant','distributeur'].forEach(k=>{if(S.extras&&S.extras[k]){const qPr=S.extras['qty'+k.charAt(0).toUpperCase()+k.slice(1)]||1;extrasCost+=qPr*25;}});
  return prodNet+customColorCost+multiColorCost+extrasCost;
}

// ══════════════════════════════════════════
// PRICING — CORRIGÉ
// Prix unitaires HT = sans logo / avec logo
// ══════════════════════════════════════════
const PRICES = {
  biberon:   { noLogo:{200:0.80,500:0.75,1000:0.70,2500:0.65,5000:0.60}, logo:{200:0.90,500:0.85,1000:0.80,2500:0.75,5000:0.70} },
  portecles: { noLogo:{200:1.20,500:1.15,1000:1.10,2500:1.05,5000:1.00}, logo:{200:1.30,500:1.25,1000:1.20,2500:1.15,5000:1.10} },
  chouchou:  { noLogo:{200:2.00,500:1.95,1000:1.90,2500:1.85,5000:1.80}, logo:{200:2.10,500:2.05,1000:2.00,2500:1.95,5000:1.90} },
  collier:        { noLogo:{100:0.80}, logo:{100:0.90} },
  paillesCarton:  { noLogo:{100:0.10,500:0.08,1000:0.06} },
  paillesInox:    { noLogo:{100:1.00,500:0.80,1000:0.60} }
};
const SHIP = {500:30,1000:40,2500:60};
const TIERS = { biberon:[200,500,1000,2500,5000], portecles:[200,500,1000,2500,5000], chouchou:[200,500,1000,2500,5000] };
const PNAMES = {biberon:'Safe Cup Biberon',portecles:'Safe Cup Porte-clés',chouchou:'Safe Cup Chouchou'};
const ZONES = {
  biberon:   {x:250,y:205,w:156,h:52,label:'4 × 2 cm'},
  // Top-view zones: between the two holes (air hole top ~y155, straw hole bottom ~y345)
  // Logo zone centered vertically between holes
  portecles: {x:250,y:245,w:185,h:72,label:'5 × 3 cm'},
  portecles_top: {x:252,y:240,w:260,h:130,label:'5 × 3 cm'},
  chouchou:  {x:250,y:250,w:185,h:72,label:'5 × 3 cm'},
  chouchou_top:  {x:252,y:240,w:260,h:130,label:'5 × 3 cm'},
  biberon_top:   {x:252,y:258,w:300,h:110,label:'4 × 2 cm'}
};

function getZone(){
  if(S.step >= 3){
    return ZONES[S.product+'_top'] || ZONES[S.product];
  }
  return ZONES[S.product];
}

// ══════════════════════════════════════════
// CANVAS
// ══════════════════════════════════════════
const canvas = document.getElementById('cv');
let ctx = canvas.getContext('2d');
let dragging = false;
// HiDPI / Retina fix
(function(){
  const dpr = window.devicePixelRatio || 1;
  if(dpr <= 1) return;
  const w = canvas.width, h = canvas.height;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  canvas.style.width = w + 'px';
  canvas.style.height = h + 'px';
  ctx.scale(dpr, dpr);
})();

function getCol(){
  if(S.color==='transparent') return null;
  return S.color;
}

function hexToRgb(hex){
  const r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  return {r,g,b};
}

function darken(hex,amt){
  if(!hex) return '#999';
  const {r,g,b}=hexToRgb(hex);
  return `rgb(${Math.max(0,r-amt)},${Math.max(0,g-amt)},${Math.max(0,b-amt)})`;
}

function lighten(hex,amt){
  if(!hex) return '#ccc';
  const {r,g,b}=hexToRgb(hex);
  return `rgb(${Math.min(255,r+amt)},${Math.min(255,g+amt)},${Math.min(255,b+amt)})`;
}

// ── Thumbnail renderer for product cards ──
function drawThumb(key){
  const tc=document.getElementById('thumb_'+key);
  if(!tc)return;
  const tx=tc.getContext('2d');
  tx.clearRect(0,0,160,160);

  // Background — white
  tx.fillStyle='#ffffff';
  tx.beginPath();tx.roundRect(0,0,160,160,10);tx.fill();

  const c='#1A1A2E'; // dark placeholder color

  if(key==='biberon'){
    if(window._biberonImg){
      const img=window._biberonImg;
      // Cover fill — same as portecles/chouchou
      const scale=Math.max(160/img.width,160/img.height);
      const w=img.width*scale,h=img.height*scale;
      tx.drawImage(img,(160-w)/2,(160-h)/2,w,h);
    } else {
      // Vector fallback
      // Biberon vector — centered for 80=80
      tx.fillStyle='rgba(180,210,240,0.3)';tx.strokeStyle='rgba(140,180,220,0.5)';tx.lineWidth=1;
      tx.beginPath();tx.roundRect(24,30,32,32,[2,2,8,8]);tx.fill();tx.stroke();
      tx.fillStyle=c;tx.strokeStyle='rgba(0,0,0,.1)';tx.lineWidth=1;
      tx.beginPath();tx.roundRect(22,18,36,16,[6,6,2,2]);tx.fill();tx.stroke();
      tx.strokeStyle='rgba(0,0,0,.25)';tx.lineWidth=2.5;tx.lineCap='round';
      tx.beginPath();tx.moveTo(40,18);tx.lineTo(48,6);tx.stroke();
      tx.fillStyle='rgba(255,255,255,0.28)';
      tx.beginPath();tx.ellipse(32,26,8,3,-0.2,0,Math.PI*2);tx.fill();
    }
  } else if(key==='portecles'){
    if(window._porteclesImg){
      const img=window._porteclesImg;
      // Cover fill
      const scale=Math.max(160/img.width,160/img.height);
      const w=img.width*scale,h=img.height*scale;
      tx.drawImage(img,(160-w)/2,(160-h)/2,w,h);
    } else {
      // Vector fallback
      tx.fillStyle='rgba(180,210,240,0.3)';tx.strokeStyle='rgba(140,180,220,0.5)';tx.lineWidth=1;
      tx.beginPath();tx.roundRect(20,34,32,24,[0,0,6,6]);tx.fill();tx.stroke();
      tx.fillStyle=c;tx.strokeStyle='rgba(0,0,0,.1)';tx.lineWidth=1;
      tx.beginPath();tx.ellipse(36,34,20,7,0,0,Math.PI*2);tx.fill();tx.stroke();
      tx.strokeStyle='rgba(180,155,80,.8)';tx.lineWidth=2;
      tx.beginPath();tx.arc(58,34,5,0,Math.PI*2);tx.stroke();
      tx.fillStyle='rgba(255,255,255,.3)';
      tx.beginPath();tx.ellipse(26,31,8,2.5,-0.1,0,Math.PI*2);tx.fill();
    }
  } else {
    // Chouchou — use real photo if loaded, else vector
    if(window._chouchouImg){
      const img=window._chouchouImg;
      // Cover fill
      const scale=Math.max(160/img.width,160/img.height);
      const w=img.width*scale,h=img.height*scale;
      tx.drawImage(img,(160-w)/2,(160-h)/2,w,h);
    } else {
      // Chouchou loops vector fallback
      for(let i=0;i<12;i++){
        const a=(i/12)*Math.PI*2,na=((i+1)/12)*Math.PI*2;
        const r1=22+(i%2===0?4:-2);
        const r2=22+((i+1)%2===0?4:-2);
        const x1=36+Math.cos(a)*r1,y1=36+Math.sin(a)*r1*0.35;
        const x2=36+Math.cos(na)*r2,y2=36+Math.sin(na)*r2*0.35;
        tx.fillStyle=i%2===0?c:darken(c,20);tx.strokeStyle='rgba(0,0,0,.06)';tx.lineWidth=0.5;
        tx.beginPath();
        tx.ellipse((x1+x2)/2,(y1+y2)/2+6,Math.abs(r1-r2)/2+6,5,a+Math.PI/2,0,Math.PI*2);
        tx.fill();tx.stroke();
      }
      tx.fillStyle='rgba(180,210,240,0.25)';tx.strokeStyle='rgba(140,180,220,0.4)';tx.lineWidth=0.8;
      tx.beginPath();tx.roundRect(26,30,20,24,[0,0,4,4]);tx.fill();tx.stroke();
    }
  }
}
['biberon','portecles','chouchou'].forEach(drawThumb);

// ── Main canvas draw ──
function draw(){
  ctx.clearRect(0,0,500,500);

  // BG
  ctx.fillStyle='#ffffff';
  ctx.fillRect(0,0,500,500);

  // Dot grid (only for vector/product views)
  if(S.product==='biberon' || S.step < 3){
    ctx.fillStyle='rgba(0,0,0,0.025)';
    for(let x=20;x<500;x+=26) for(let y=20;y<500;y+=26){
      ctx.beginPath();ctx.arc(x,y,1,0,Math.PI*2);ctx.fill();
    }
  }

  const c = getCol() || 'rgba(210,228,248,0.5)';
  const isTransparent = !getCol();

  ctx.save();

  // Step logic
  const isSummary = S.step===5; // step résumé
  const isLogoStep = S.perso && S.step===3;
  if(isSummary && !S.perso){
    // Sans perso : image générique
    drawSummaryImage();
  } else if(isSummary && S.perso){
    // Avec perso résumé : même vue que l'étape logo (top view + logo)
    drawTopView(c, isTransparent);
  } else if(isLogoStep){
    drawTopView(c, isTransparent);
  } else if(S.product==='biberon' && S.step===2 && S.packaging==='kraft' && _kraftImgLoaded){
    const scale = Math.min(460/_kraftImgLoaded.width, 460/_kraftImgLoaded.height);
    const w = _kraftImgLoaded.width*scale, h = _kraftImgLoaded.height*scale;
    ctx.drawImage(_kraftImgLoaded, (500-w)/2, (500-h)/2, w, h);
  } else if(S.product==='biberon'){
    drawBiberon(c, isTransparent);
  } else if(S.product==='portecles'){
    drawPortecles(c, isTransparent);
  } else {
    drawChouchou(c, isTransparent);
  }

  ctx.restore();

  if(S.step >= 3 && S.perso && !window._skipZone) drawPrintZone();
  if(S.step >= 3 && S.perso) drawLogo();
  drawWatermark();

}

function drawColorBadge(c){
  const r=52;
  const bx=500-r-16; // haut droite
  const by=r+16;
  ctx.save();
  // Ombre portée
  ctx.shadowColor='rgba(0,0,0,0.22)';ctx.shadowBlur=16;ctx.shadowOffsetY=4;
  // Pastille
  ctx.beginPath();ctx.arc(bx,by,r,0,Math.PI*2);
  ctx.fillStyle=c;ctx.fill();
  ctx.shadowColor='transparent';
  // Bordure blanche
  ctx.strokeStyle='rgba(255,255,255,0.95)';ctx.lineWidth=3.5;
  ctx.beginPath();ctx.arc(bx,by,r,0,Math.PI*2);ctx.stroke();
  // Texte blanc avec ombre pour lisibilité sur toute couleur
  ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.shadowColor='rgba(0,0,0,0.6)';ctx.shadowBlur=6;
  ctx.fillStyle='#ffffff';
  ctx.font='bold 11px DM Sans,sans-serif';
  ctx.fillText('Votre couleur',bx,by-12);
  ctx.fillText('sur mesure',bx,by+1);
  ctx.font='10px DM Sans,sans-serif';
  ctx.fillStyle='rgba(255,255,255,0.88)';
  ctx.fillText(c.toUpperCase(),bx,by+14);
  ctx.restore();
}

function drawSummaryImage(){
  const img = _summaryImgLoaded;
  if(img){
    const scale = Math.min(460/img.width, 460/img.height);
    const w = img.width*scale, h = img.height*scale;
    ctx.drawImage(img, (500-w)/2, (500-h)/2, w, h);
  }
}

function drawTopView(c, isTransp){
  // Custom color + chouchou/portecles at logo step → use grey neutral view
  const useNeutral = S.customColor && (S.product==='portecles'||S.product==='chouchou');
  const key = useNeutral ? 'gris' : getTopViewKey(S.colorName, S.color);
  const img = _topViewImgs[key];

  if(img){
    const scale = Math.min(460/img.width, 460/img.height);
    const w = img.width * scale;
    const h = img.height * scale;
    const dx = (500 - w) / 2;
    const dy = (500 - h) / 2;
    ctx.save();
    if(useNeutral && _topViewImgs['gris']){
      const gi=_topViewImgs['gris'];
      const gs=Math.min(460/gi.width,460/gi.height);
      ctx.drawImage(gi,(500-gi.width*gs)/2,(500-gi.height*gs)/2,gi.width*gs,gi.height*gs);
    } else {
      ctx.drawImage(img, dx, dy, w, h);
    }
    ctx.restore();
    // Draw color badge for custom color
    if(S.customColor && c && S.perso) drawColorBadge(c);
  } else {
    ctx.fillStyle='#f0f0f0';
    ctx.fillRect(0,0,500,500);
    ctx.fillStyle='#aaa';
    ctx.font='14px DM Sans,sans-serif';
    ctx.textAlign='center';
    ctx.fillText("Chargement de l'aperçu...", 250, 250);
    setTimeout(()=>{ if(S.step>=3) draw(); }, 200);
  }
}

function drawBiberon(c, isTransp){
  if(window._biberonImg){
    drawBiberonFromPhoto(c, isTransp);
    return;
  }
  drawBiberonVector(c, isTransp);
}

function drawBiberonFromPhoto(c, isTransp){
  const img = window._biberonImg;
  // Full image, contain in canvas (no crop)
  const scale = Math.min(460/img.width, 460/img.height);
  const w = img.width * scale;
  const h = img.height * scale;
  const dx = (500 - w) / 2;
  const dy = (500 - h) / 2;

  ctx.save();
  ctx.drawImage(img, dx, dy, w, h);

  // Color overlay on lid if custom color selected
  if(!isTransp && c !== '#FFFFFF' && c !== 'rgba(210,228,248,0.5)'){
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = c;
    ctx.beginPath();
    ctx.roundRect(dx + w*0.10, dy + h*0.02, w*0.50, h*0.38, 14);
    ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
  }
  ctx.restore();
}

function drawBiberonVector(c, isTransp){
  // Shadow
  ctx.shadowColor='rgba(0,0,0,.08)';ctx.shadowBlur=40;ctx.shadowOffsetY=10;

  // Glass body
  const grd=ctx.createLinearGradient(175,175,325,375);
  grd.addColorStop(0,'rgba(220,235,250,0.28)');
  grd.addColorStop(1,'rgba(190,215,245,0.15)');
  ctx.fillStyle=grd;
  ctx.strokeStyle='rgba(160,200,240,0.35)';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.roundRect(177,185,146,195,[4,4,20,20]);ctx.fill();ctx.stroke();

  ctx.shadowColor='rgba(0,0,0,.14)';ctx.shadowBlur=28;ctx.shadowOffsetY=6;

  // Lid base (connector between lid and body)
  ctx.fillStyle=isTransp?'rgba(200,220,240,0.5)':darken(c,15);
  ctx.strokeStyle='rgba(0,0,0,.06)';ctx.lineWidth=1;
  ctx.beginPath();ctx.roundRect(182,212,136,12,[0,0,2,2]);ctx.fill();ctx.stroke();

  // Main lid
  ctx.fillStyle=c;
  ctx.strokeStyle='rgba(0,0,0,.07)';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.roundRect(173,138,154,80,[16,16,6,6]);ctx.fill();ctx.stroke();

  ctx.shadowColor='transparent';

  // Lid bottom rim
  ctx.fillStyle=isTransp?'rgba(180,205,230,0.4)':darken(c,20);
  ctx.beginPath();ctx.roundRect(173,210,154,10,[2,2,0,0]);ctx.fill();

  // Lid shine / highlight
  ctx.fillStyle='rgba(255,255,255,0.28)';
  ctx.beginPath();ctx.roundRect(182,145,60,25,[8,8,6,6]);ctx.fill();
  ctx.fillStyle='rgba(255,255,255,0.12)';
  ctx.beginPath();ctx.roundRect(182,175,80,15,[4,4,4,4]);ctx.fill();

  // Straw hole
  ctx.fillStyle='rgba(0,0,0,0.2)';
  ctx.beginPath();ctx.ellipse(250,141,8,4.5,0,0,Math.PI*2);ctx.fill();

  // Straw
  const sg=ctx.createLinearGradient(248,50,258,145);
  sg.addColorStop(0,'rgba(120,120,130,0.4)');
  sg.addColorStop(1,'rgba(80,80,90,0.25)');
  ctx.strokeStyle=sg;ctx.lineWidth=8;ctx.lineCap='round';
  ctx.beginPath();ctx.moveTo(250,141);ctx.lineTo(265,60);ctx.stroke();
  // Straw shine
  ctx.strokeStyle='rgba(255,255,255,0.25)';ctx.lineWidth=2.5;
  ctx.beginPath();ctx.moveTo(247,141);ctx.lineTo(262,60);ctx.stroke();

  // Glass body shine
  ctx.fillStyle='rgba(255,255,255,0.22)';
  ctx.beginPath();ctx.roundRect(187,196,30,170,[6,6,4,4]);ctx.fill();

  // Water ripple lines in glass
  for(let i=0;i<3;i++){
    const wy=300+i*28;
    ctx.strokeStyle=`rgba(160,195,230,${0.2-i*0.05})`;ctx.lineWidth=1;
    ctx.beginPath();ctx.moveTo(188,wy);ctx.bezierCurveTo(220,wy-4,280,wy+4,312,wy);ctx.stroke();
  }
}


function drawPortecles(c, isTransp){
  const key = (() => {
    if(S.colorName==='Noir'||S.color==='#1A1A1A') return 'noir';
    if(S.colorName==='Blanc'||S.color==='#FFFFFF') return 'blanc';
    if(S.colorName==='Bleu'||S.color==='#3B9EBF') return 'turquoise';
    if(S.colorName==='Rose'||S.color==='#FF6B9D') return 'rose';
    return 'noir'; // custom color: use noir as base
  })();
  const colorImg = _pcViewImgs[key];
  if(colorImg){
    const scale = Math.min(460/colorImg.width, 460/colorImg.height);
    const w = colorImg.width*scale, h = colorImg.height*scale;
    ctx.drawImage(colorImg, (500-w)/2, (500-h)/2, w, h);
    // Apply custom color overlay
    if(S.customColor && c && S.perso) drawColorBadge(c);
    return;
  }
  if(window._porteclesImg){ drawPorteclesFromPhoto(c, isTransp); return; }
  drawPorteclesVector(c, isTransp);
}

function drawPorteclesFromPhoto(c, isTransp){
  const img = window._porteclesImg;
  // White bg, full product visible — scale to fit nicely
  const scale = Math.min(460/img.width, 460/img.height);
  const w = img.width * scale;
  const h = img.height * scale;
  const x = (500 - w) / 2;
  const y = (500 - h) / 2 + 5;

  ctx.save();
  ctx.drawImage(img, x, y, w, h);

  // Color overlay on the cap (top of cup) if custom color selected
  if(!isTransp && c !== '#FFFFFF' && c !== 'rgba(210,228,248,0.5)'){
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = c;
    // Cap area — ellipse covering the lid on top of the cup
    ctx.beginPath();
    ctx.ellipse(x + w*0.42, y + h*0.19, w*0.36, h*0.14, 0, 0, Math.PI*2);
    ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
  }
  ctx.restore();
}

function drawPorteclesVector(c, isTransp){
  ctx.shadowColor='rgba(0,0,0,.1)';ctx.shadowBlur=36;ctx.shadowOffsetY=8;

  // Cup body
  const bodyGrd=ctx.createLinearGradient(180,255,320,380);
  bodyGrd.addColorStop(0,'rgba(220,235,250,0.28)');
  bodyGrd.addColorStop(1,'rgba(190,215,245,0.15)');
  ctx.fillStyle=bodyGrd;ctx.strokeStyle='rgba(160,200,240,0.35)';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.roundRect(182,262,136,118,[0,0,18,18]);ctx.fill();ctx.stroke();

  ctx.shadowColor='rgba(0,0,0,.16)';ctx.shadowBlur=24;ctx.shadowOffsetY=5;

  // Outer rim
  ctx.fillStyle=isTransp?'rgba(190,210,235,0.55)':darken(c,18);
  ctx.strokeStyle='rgba(0,0,0,.06)';ctx.lineWidth=1;
  ctx.beginPath();ctx.ellipse(250,250,122,33,0,0,Math.PI*2);ctx.fill();ctx.stroke();

  // Main cap
  ctx.fillStyle=c;ctx.strokeStyle='rgba(0,0,0,.07)';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.ellipse(250,250,115,29,0,0,Math.PI*2);ctx.fill();ctx.stroke();

  ctx.shadowColor='transparent';

  // Cap shine
  ctx.fillStyle='rgba(255,255,255,0.32)';
  ctx.beginPath();ctx.ellipse(218,241,40,10,-0.2,0,Math.PI*2);ctx.fill();
  ctx.fillStyle='rgba(255,255,255,0.15)';
  ctx.beginPath();ctx.ellipse(218,252,32,7,-0.1,0,Math.PI*2);ctx.fill();

  // Key ring
  const kr=ctx.createLinearGradient(350,230,390,270);
  kr.addColorStop(0,'rgba(210,175,60,.9)');kr.addColorStop(1,'rgba(170,135,40,.7)');
  ctx.strokeStyle=kr;ctx.lineWidth=6;
  ctx.beginPath();ctx.arc(376,250,21,0,Math.PI*2);ctx.stroke();
  ctx.strokeStyle='rgba(190,155,45,.8)';ctx.lineWidth=4;
  ctx.beginPath();ctx.moveTo(355,250);ctx.lineTo(365,250);ctx.stroke();
  ctx.strokeStyle='rgba(255,230,120,.5)';ctx.lineWidth=2;
  ctx.beginPath();ctx.arc(376,250,21,Math.PI*1.2,Math.PI*1.8);ctx.stroke();

  // Serrated edge detail
  for(let i=0;i<20;i++){
    const a=(i/20)*Math.PI*2;
    const x=250+Math.cos(a)*115,y=250+Math.sin(a)*115*0.252;
    ctx.fillStyle='rgba(0,0,0,0.04)';
    ctx.beginPath();ctx.arc(x,y,2.5,0,Math.PI*2);ctx.fill();
  }

  // Glass body shine
  ctx.fillStyle='rgba(255,255,255,0.2)';
  ctx.beginPath();ctx.roundRect(190,270,25,100,[6,6,4,4]);ctx.fill();
}

function drawChouchou(c, isTransp){
  const key = (() => {
    if(S.colorName==='Noir'||S.color==='#1A1A1A') return 'noir';
    if(S.colorName==='Blanc'||S.color==='#FFFFFF') return 'blanc';
    if(S.colorName==='Bleu'||S.color==='#3B9EBF') return 'turquoise';
    if(S.colorName==='Rose'||S.color==='#FF6B9D') return 'rose';
    return 'blanc';
  })();
  const colorImg = _chViewImgs[key];
  if(colorImg){
    const scale = Math.min(460/colorImg.width, 460/colorImg.height);
    const w = colorImg.width*scale, h = colorImg.height*scale;
    ctx.drawImage(colorImg, (500-w)/2, (500-h)/2, w, h);
    if(S.customColor && c && S.perso) drawColorBadge(c);
    return;
  }
  if(window._chouchouImg){ drawChouchouFromPhoto(c, isTransp); return; }
  drawChouchouVector(c, isTransp);
}
function drawChouchouFromPhoto(c, isTransp){
  const img = window._chouchouImg;
  // Draw photo centered, scaled to fit canvas
  const scale = Math.min(500/img.width, 420/img.height);
  const w = img.width * scale;
  const h = img.height * scale;
  const x = (500 - w) / 2;
  const y = (500 - h) / 2 + 10;

  ctx.save();
  ctx.drawImage(img, x, y, w, h);

  // If a custom color is selected (not transparent/black), apply color overlay
  if(!isTransp && c !== '#1A1A1A' && c !== 'rgba(210,228,248,0.5)'){
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = c;
    // Only colorize the product area (approximate bounding box of chouchou)
    ctx.beginPath();
    ctx.ellipse(250, 290, 160, 120, 0, 0, Math.PI*2);
    ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
  }

  // Logo zone overlay (print area on the cap)
  ctx.restore();
}

function drawChouchouVector(c, isTransp){
  const sc = isTransp ? 'rgba(100,100,115,0.7)' : c;

  ctx.shadowColor='rgba(0,0,0,.1)';ctx.shadowBlur=24;ctx.shadowOffsetY=5;

  // Ruffle loops
  for(let i=0;i<22;i++){
    const a=(i/22)*Math.PI*2,na=((i+1)/22)*Math.PI*2;
    const r1=118+(i%2===0?16:-5),r2=118+((i+1)%2===0?16:-5);
    const x1=250+Math.cos(a)*r1,y1=250+Math.sin(a)*r1*0.34;
    const x2=250+Math.cos(na)*r2,y2=250+Math.sin(na)*r2*0.34;
    const mx=(x1+x2)/2,my=(y1+y2)/2;
    ctx.fillStyle=i%3===0?lighten(sc,20):(i%3===1?sc:darken(sc,15));
    ctx.strokeStyle='rgba(0,0,0,0.06)';ctx.lineWidth=0.8;
    ctx.beginPath();
    ctx.ellipse(mx,my,Math.abs(r1-r2)/2+19,16,a+Math.PI/2,0,Math.PI*2);
    ctx.fill();ctx.stroke();
  }

  ctx.shadowColor='transparent';

  // Center elastic band
  ctx.strokeStyle='rgba(0,0,0,0.12)';ctx.lineWidth=3;
  ctx.beginPath();ctx.ellipse(250,250,62,18,0,0,Math.PI*2);ctx.stroke();

  // Cup body
  const bodyGrd=ctx.createLinearGradient(195,200,305,325);
  bodyGrd.addColorStop(0,'rgba(220,235,250,0.3)');
  bodyGrd.addColorStop(1,'rgba(190,215,245,0.15)');
  ctx.fillStyle=bodyGrd;ctx.strokeStyle='rgba(160,200,240,0.35)';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.roundRect(196,202,108,120,[0,0,14,14]);ctx.fill();ctx.stroke();

  // Cup shine
  ctx.fillStyle='rgba(255,255,255,0.2)';
  ctx.beginPath();ctx.roundRect(204,210,20,105,[4,4,3,3]);ctx.fill();
}

function drawPrintZone(){
  const z=getZone();
  ctx.save();
  ctx.strokeStyle='rgba(210,100,0,0.85)';ctx.lineWidth=2;
  ctx.setLineDash([6,4]);
  ctx.beginPath();ctx.roundRect(z.x-z.w/2,z.y-z.h/2,z.w,z.h,6);ctx.stroke();
  ctx.setLineDash([]);
  ctx.fillStyle='rgba(210,100,0,0.06)';
  ctx.beginPath();ctx.roundRect(z.x-z.w/2,z.y-z.h/2,z.w,z.h,6);ctx.fill();
  if(!S.logoImg){
    ctx.fillStyle='rgba(180,80,0,0.9)';
    ctx.font='bold 11px DM Sans,sans-serif';ctx.textAlign='center';
    ctx.fillText('Zone d\'impression ('+z.label+')',z.x,z.y+4);
  }
  ctx.restore();
}

function drawLogo(){
  if(!S.logoImg)return;
  ctx.save();
  const z=getZone();
  const scale=S.lsize/100;
  // Dimensions logo contraintes à la zone
  let lw=z.w*scale;
  let lh=(S.logoImg.height/S.logoImg.width)*lw;
  if(lh>z.h){lh=z.h;lw=(S.logoImg.width/S.logoImg.height)*lh;}
  if(lw>z.w){lw=z.w;lh=(S.logoImg.height/S.logoImg.width)*lw;}
  // Toujours centré dans la zone
  const cx=z.x;
  const cy=z.y;
  // Clip à la zone
  ctx.beginPath();
  ctx.roundRect(z.x-z.w/2,z.y-z.h/2,z.w,z.h,6);
  ctx.clip();
  ctx.drawImage(S.logoImg,cx-lw/2,cy-lh/2,lw,lh);
  ctx.restore();
}

function drawWatermark(){
  ctx.save();
  // Logo watermark bottom right
  if(window._logoRondImg){
    ctx.globalAlpha=0.07;
    ctx.drawImage(window._logoRondImg, 418, 424, 72, 72);
  } else {
    ctx.globalAlpha=0.08;
    ctx.fillStyle='#1A1A2E';ctx.font='bold 10px sans-serif';ctx.textAlign='right';
    ctx.fillText('MY SAFE CUP',492,492);
  }
  ctx.restore();
}

// ── Canvas drag ──
canvas.addEventListener('mousedown',e=>{
  if(!S.logoImg||S.step<3)return;
  return; // Logo always centered — drag disabled
  const r=canvas.getBoundingClientRect();
  const dpr=window.devicePixelRatio||1;
  S.lx=(e.clientX-r.left)*(canvas.width/r.width)/dpr;
  S.ly=(e.clientY-r.top)*(canvas.height/r.height)/dpr;
  dragging=true;draw();
});
canvas.addEventListener('mousemove',e=>{
  if(!dragging)return;
  const r=canvas.getBoundingClientRect();
  const dpr=window.devicePixelRatio||1;
  S.lx=(e.clientX-r.left)*(canvas.width/r.width)/dpr;
  S.ly=(e.clientY-r.top)*(canvas.height/r.height)/dpr;
  draw();
});
canvas.addEventListener('mouseup',()=>dragging=false);
canvas.addEventListener('mouseleave',()=>dragging=false);
canvas.addEventListener('touchstart',handleTouch,{passive:true});
canvas.addEventListener('touchmove',handleTouch,{passive:true});
canvas.addEventListener('touchend',()=>dragging=false);
function handleTouch(e){
  if(!S.logoImg||S.step<3)return;
  const t=e.touches[0],r=canvas.getBoundingClientRect();
  const dpr=window.devicePixelRatio||1;
  S.lx=(t.clientX-r.left)*(canvas.width/r.width)/dpr;
  S.ly=(t.clientY-r.top)*(canvas.height/r.height)/dpr;
  draw();
}

// ══════════════════════════════════════════
// STEPS
// ══════════════════════════════════════════
function goStep(n){
  S.step=n;

  // Ordre visuel réel des étapes selon le contexte
  // Sans perso : [1,2,4,5] → steps data-s
  // Avec perso sans collier : [1,2,3,4,5]
  // Avec perso + collier : [1,2,3,4,6,5] (collier=6 avant résumé=5)
  const getOrder = () => {
    if(!S.perso) return [1,2,4,5];
    if(!S.collierPerso) return [1,2,3,4,5];
    return [1,2,3,4,5]; // collier perso supprimé
  };
  const order = getOrder();
  const currentIdx = order.indexOf(n);

  document.querySelectorAll('.st').forEach((el)=>{
    const s = parseInt(el.dataset.s);
    const stepIdx = order.indexOf(s);
    if(stepIdx === -1){ el.classList.remove('active','done'); return; }
    const isActive = s === n;
    const isDone = stepIdx < currentIdx;
    el.classList.toggle('active', isActive);
    el.classList.toggle('done', isDone && !isActive);
  });

  // Mapping step → blkID
  // blk1=Produit, blk2=Couleur, blk3=Logo, blk5=Extras, blk6=Résumé
  const blkId = S.perso
    ? {1:'blk1',2:'blk2',3:'blk3',4:'blk6',5:'blk6'}[n]
    : {1:'blk1',2:'blk2',3:'blk6',4:'blk6',5:'blk6'}[n];

  document.querySelectorAll('.blk').forEach(el=>{
    el.classList.toggle('on', el.id===blkId);
  });

  // Extras step : bannière offert + badge présentoirs
  const isExtras = (blkId === 'blk5');
  if(isExtras) updatePresentoirOffert();

  if(n===5) S.destination = S.destination || 'France';

  if(n===1) switchView('gif');
  else switchView('canvas');
  updatePrevLabel();

  // Canvas collier step 6
  const collierWrap = document.getElementById('collierCanvasWrap');
  const collierActs = document.getElementById('collierActsWrap');
  const mainCanvas = document.getElementById('canvasWrap');
  if(n===6){
    if(collierWrap) collierWrap.style.display='block';
    if(collierActs) collierActs.style.display = S.collierLogo ? 'flex' : 'none';
    if(mainCanvas) mainCanvas.style.display='none';
    drawCollierCanvas();
  } else {
    if(collierWrap) collierWrap.style.display='none';
    if(collierActs) collierActs.style.display='none';
  }

  // Masquer le message designer sur tous les steps sauf 3 et 6
  const designerMsg = document.getElementById('designerMsg');
  if(designerMsg && n !== 3 && n !== 6) designerMsg.style.display = 'none';
  const mainEl = document.querySelector('.main');
  const showingExtras = (blkId === 'blk5');
  const showingResume = (blkId === 'blk6');
  if(mainEl) mainEl.classList.toggle('extras-mode', showingExtras || showingResume);
  document.body.offsetHeight;
  if(n===2){
    const minQ = S.perso ? 500 : 200;
    if(S.qty < minQ){ S.qty = minQ; document.getElementById('qtyInput').value = minQ; }
    else document.getElementById('qtyInput').value = S.qty;
    updateLivePrice();
  }
  const w=document.getElementById('customColorWarning');
  if(w) w.style.display = (n===2 && S.customColor && S.perso) ? 'block' : 'none';
  const btnReset = document.getElementById('btnReset');
  if(btnReset) btnReset.style.display = (S.perso && n>=3 && n!==6) ? 'inline-flex' : 'none';
  const btnDl = document.getElementById('btnDl');
  if(btnDl) btnDl.style.display = (S.perso && n>=3 && n!==6) ? 'flex' : 'none';
  const prevHint = document.getElementById('prevHint');
  if(prevHint) prevHint.style.display = 'none';
  document.querySelector('.left').scrollTop=0;
}
document.querySelectorAll('.st').forEach(t=>t.addEventListener('click',()=>goStep(parseInt(t.dataset.s))));

// ══════════════════════════════════════════
// PRODUCT
// ══════════════════════════════════════════
// Packaging state
S.packaging = 'pvc';

function selPackaging(type, el){
  S.packaging = type;
  document.querySelectorAll('.pkg-opt').forEach(e=>e.classList.remove('sel'));
  el.classList.add('sel');
  draw();
}

function updatePackagingVisibility(){
  // Biberon
  const section = document.getElementById('packagingSection');
  if(section) section.style.display = S.product==='biberon' ? 'block' : 'none';
  const noPerso = document.getElementById('pkgNoPerso');
  const withPerso = document.getElementById('pkgPerso');
  if(noPerso) noPerso.style.display = S.perso ? 'none' : 'flex';
  if(withPerso) withPerso.style.display = S.perso ? 'flex' : 'none';
  if(withPerso && S.perso) withPerso.style.flexDirection = 'column';
  // Porte-clés
  const sectionPK = document.getElementById('packagingSectionPK');
  if(sectionPK) sectionPK.style.display = S.product==='portecles' ? 'block' : 'none';
  const noPersoPK = document.getElementById('pkgPKNoPerso');
  const withPersoPK = document.getElementById('pkgPKPerso');
  if(noPersoPK) noPersoPK.style.display = S.perso ? 'none' : 'flex';
  if(withPersoPK) withPersoPK.style.display = S.perso ? 'flex' : 'none';
  if(withPersoPK && S.perso) withPersoPK.style.flexDirection = 'column';
  // Chouchou
  const sectionCH = document.getElementById('packagingSectionCH');
  if(sectionCH) sectionCH.style.display = S.product==='chouchou' ? 'block' : 'none';
  const noPersoCH = document.getElementById('pkgCHNoPerso');
  const withPersoCH = document.getElementById('pkgCHPerso');
  if(noPersoCH) noPersoCH.style.display = S.perso ? 'none' : 'flex';
  if(withPersoCH) withPersoCH.style.display = S.perso ? 'flex' : 'none';
  if(withPersoCH && S.perso) withPersoCH.style.flexDirection = 'column';
}

function renderSwatches(){
  const isBiberon = S.product === 'biberon';
  const swatchDefs = isBiberon
    ? [{c:'transparent',n:'Transparent',style:'background:repeating-conic-gradient(#ddd 0% 25%,#fff 0% 50%) 0 0/10px 10px'}]
    : [
        {c:'#1A1A1A',n:'Noir',style:'background:#1A1A1A'},
        {c:'#FFFFFF',n:'Blanc',style:'background:#fff;border:2px solid #ddd'},
        {c:'#3B9EBF',n:'Bleu',style:'background:#3B9EBF'},
        {c:'#FF6B9D',n:'Rose',style:'background:#FF6B9D'},
      ];
  const container = document.getElementById('swatches');
  container.innerHTML = swatchDefs.map(sw => `
    <div class="swatch-wrap">
      <div class="sw${S.color===sw.c?' sel':''}" data-c="${sw.c}" data-n="${sw.n}"
        onclick="selCol(this)" title="${sw.n}" style="${sw.style}"></div>
      <div class="sw-label">${sw.n}</div>
    </div>`).join('');
  // If current color not available for this product, reset to first available
  const available = swatchDefs.map(s=>s.c);
  if(!available.includes(S.color)){
    const first = swatchDefs[0];
    S.color = first.c;
    S.colorName = first.n;
    S.customColor = false;
  }
}

function selProd(el){
  document.querySelectorAll('.pcard').forEach(c=>c.classList.remove('sel'));
  el.classList.add('sel');
  S.product=el.dataset.p;
  S.lx=ZONES[S.product].x;S.ly=ZONES[S.product].y;
  const z=ZONES[S.product];
  const zoneInfoEl = document.getElementById('zoneInfo');
  if(zoneInfoEl) zoneInfoEl.innerHTML=`Zone d'impression : <strong>${z.label}</strong> (${PNAMES[S.product]}). PNG ou SVG avec fond transparent recommandé.`;
  // Reset qty to product MOQ
  const newMin = S.perso ? 500 : 200;
  if(S.qty < newMin){ S.qty = newMin; document.getElementById('qtyInput').value = newMin; }
  document.getElementById('qtyMinTag').textContent = 'Min. '+newMin+' unités';
  renderSwatches();
  updatePackagingVisibility();
  updateTiers();
  draw();
  updateGif();
  updatePrevLabel();
}

function updatePrevLabel(){
  const lbl = document.getElementById('prevLbl');
  if(!lbl) return;
  if(S.step === 6){ lbl.textContent = 'Collier Porte-gobelet'; return; }
  const names = {biberon:'Biberon', portecles:'Porte-clés', chouchou:'Chouchou'};
  const name = names[S.product] || '';
  const isLogoStep = S.perso && S.step === 3;
  lbl.textContent = name
    ? 'Format ' + name + (isLogoStep ? ' — Vue de dessus' : '')
    : '✦ Aperçu temps réel';
}

function updateGif(){
  const gif = document.getElementById('gifImg');
  if(!gif) return;
  const url = GIF_URLS[S.product];
  if(!url || url.indexOf('TODO') !== -1) return;
  gif.src = url;
}

function switchView(mode){
  const gifWrap = document.getElementById('gifWrap');
  const canvasWrap = document.getElementById('canvasWrap');
  const hint = document.getElementById('prevHint');
  if(mode==='gif'){
    gifWrap.style.display='flex';
    canvasWrap.style.display='none';
    if(hint) hint.innerHTML='<span>▶</span> Démo du produit en action';
  } else {
    gifWrap.style.display='none';
    canvasWrap.style.display='flex';
    if(hint) hint.innerHTML="";
    draw();
  }
}

// ══════════════════════════════════════════
// PERSO TOGGLE
// ══════════════════════════════════════════
function togglePerso(){
  S.perso=!S.perso;
  document.getElementById('tog').classList.toggle('on',S.perso);
  document.getElementById('togRow').classList.toggle('on',S.perso);
  // Update steps bar visibility
  const logoTab=document.getElementById('stepLogoTab');
  const sumTab=document.getElementById('stepSumTab');
  if(logoTab) logoTab.style.display=S.perso?'flex':'none';
  updateStepNumbers();
  // Update qty min
  const minQty = S.perso ? 500 : 200;
  document.getElementById('qtyMinTag').textContent='Min. '+minQty+' unités';
  if(S.qty<minQty){S.qty=minQty;document.getElementById('qtyInput').value=minQty;}
  updateLivePrice();
  // Update step 2 button label
  const s2btn=document.getElementById('step2NextBtn');
  if(s2btn) s2btn.textContent=S.perso?'Importer mon logo →':'Voir le résumé →';
  // Show/hide custom color and BAT note
  const ccs = document.getElementById('customColorSection');
  if(ccs) ccs.style.display = S.perso ? 'flex' : 'none';
  const batNote = document.getElementById('batNote');
  if(batNote) batNote.style.display = S.perso ? 'block' : 'none';
  updateTiers();
  updatePackagingVisibility();
  draw();
}
// Init perso state
S.perso = false;
S.destination = 'France'; // default
// Hide logo step tab initially
function updateStepNumbers(){
  // Sans perso → 1-2-3(Résumé)
  // Avec perso, sans collier → 1-2-3(Logo)-4(Résumé)
  // Avec perso + collier → 1-2-3(Logo)-4(Collier)-5(Résumé)
  const sumTab = document.getElementById('stepSumTab');
  const collierSn = document.querySelector('#stepCollierTab .sn');
  if(!S.perso){
    if(sumTab) sumTab.querySelector('.sn').textContent = '3';
  } else {
    if(sumTab) sumTab.querySelector('.sn').textContent = '4';
  }
}

document.addEventListener('DOMContentLoaded',()=>{
  const lt=document.getElementById('stepLogoTab');
  if(lt) lt.style.display='none';
  updateStepNumbers();
});

// ══════════════════════════════════════════
// TIERS
// ══════════════════════════════════════════
function roundQty(el){
  const min = S.perso ? 500 : 200;
  let v = parseInt(el.value) || min;
  // Round to nearest 100
  v = Math.round(v / 100) * 100;
  v = Math.max(min, v);
  S.qty = v;
  el.value = v;
  updQtyHint();
  updateTiers();
  draw();
  updateLivePrice();
}

function updateLivePrice(){
  if(S.step !== 2) return;
  const q = S.qty;
  const up = getUnitPrice();
  if(!up) return;
  const colorExtra = S.customColor ? 0.10 : 0;
  const upTotal = up + colorExtra;
  const total = upTotal * q;
  const disc = S.promoDisc ? total * S.promoDisc : 0;
  const finalTotal = total - disc;
  const el = document.getElementById('liveTotal');
  const elU = document.getElementById('liveUnit');
  if(el) el.textContent = finalTotal.toLocaleString('fr', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  const unitLabel = upTotal.toFixed(2) + ' € / u' + (S.customColor ? ' (+0,10€ couleur)' : '') + ' · ' + q.toLocaleString('fr') + ' u';
  if(elU) elU.textContent = unitLabel;
}

function updateTiers(){
  const grid=document.getElementById('tierGrid');
  const allTiers=TIERS[S.product]||TIERS['portecles'];
  // With logo: min 500u, hide 200u tier
  const tiers = S.perso ? allTiers.filter(t=>t>=500) : allTiers;
  const p=PRICES[S.product];
  grid.innerHTML=tiers.map(q=>{
    const price=S.perso?p.logo[q]:p.noLogo[q];
    const isActive=S.qty>=q&&(S.qty<(tiers[tiers.indexOf(q)+1]||Infinity));
    return `<div class="tier${isActive?' active':''}">
      <div class="tier-qty">${q>=1000?q/1000+'k':q} u</div>
      <div class="tier-price">${price.toFixed(2)} €</div>
    </div>`;
  }).join('');
}

// ══════════════════════════════════════════
// COLOR
// ══════════════════════════════════════════
function selCol(el){
  document.querySelectorAll('.sw').forEach(s=>s.classList.remove('sel'));
  el.classList.add('sel');
  S.color=el.dataset.c;S.colorName=el.dataset.n;S.customColor=false;
  if(S.step>=2) switchView('canvas');
  document.getElementById('customColorWarning').style.display='none';
  draw();
}
function selCustomCol(inp){
  document.querySelectorAll('.sw').forEach(s=>s.classList.remove('sel'));
  S.color=inp.value;S.colorName='Personnalisée ('+inp.value+')';S.customColor=true;
  if(S.step>=2) switchView('canvas');
  document.getElementById('customColorWarning').style.display=(S.perso?'block':'none');
  draw();
}

// ══════════════════════════════════════════
// QTY
// ══════════════════════════════════════════
function adjQty(d){
  const min=S.perso?500:200;
  S.qty=Math.max(min,S.qty+d);
  document.getElementById('qtyInput').value=S.qty;
  updQtyHint();updateTiers();updateLivePrice();
}
function onQtyInput(el){
  const min=S.perso?500:200;
  const v=parseInt(el.value)||min;
  S.qty=Math.max(min,v);;
  updQtyHint();updateTiers();
}
function updQtyHint(){
  const delay = S.perso ? 'Délai 15–20 jours ouvrés' : 'Délai 2–3 jours ouvrés';
  document.getElementById('qtyHint').textContent = delay;
}

// ══════════════════════════════════════════
// LOGO UPLOAD
// ══════════════════════════════════════════
const dz=document.getElementById('upzone');
dz.addEventListener('dragover',e=>{e.preventDefault();dz.classList.add('drag')});
dz.addEventListener('dragleave',()=>dz.classList.remove('drag'));
dz.addEventListener('drop',e=>{e.preventDefault();dz.classList.remove('drag');const f=e.dataTransfer.files[0];if(f)processFile(f);});
function handleUpload(e){const f=e.target.files[0];if(f)processFile(f);}
function processFile(f){
  if(f.size>5*1024*1024){toast('❌','Fichier trop lourd (max 5 MB)');return;}
  S.logoFile=f;
  S.logoCloudUrl=null;
  // Upload Cloudinary en arrière-plan
  uploadToCloudinary(f, 'logo_protection').then(url=>{
    S.logoCloudUrl = url;
    if(url) console.log('Logo protection uploadé:', url);
  });
  const r=new FileReader();
  r.onload=ev=>{
    const img=new Image();
    img.onload=()=>{
      S.logoImg=img;
      const z=getZone();S.lx=z.x;S.ly=z.y;
      draw();
      document.getElementById('lrow').classList.add('vis');
      document.getElementById('lthumb').src=ev.target.result;
      document.getElementById('lfn').textContent=f.name;
      document.getElementById('logoCtrl').style.display='flex';
      const msg=document.getElementById('designerMsg');
      if(msg) msg.style.display='block';
      toast('✅','Logo importé avec succès !');
    };
    img.src=ev.target.result;
  };
  r.readAsDataURL(f);
}
function removeLogo(){
  S.logoImg=null;S.logoFile=null;
  document.getElementById('lrow').classList.remove('vis');
  document.getElementById('logoCtrl').style.display='none';
  document.getElementById('fileIn').value='';
  const msg=document.getElementById('designerMsg');
  if(msg) msg.style.display='none';
  draw();
}
function resetLogo(){
  // Clear logo state
  S.logoImg = null;
  S.logoFile = null;
  S.lsize = 60;
  S.lopac = 100;
  const z = getZone();
  S.lx = z.x; S.ly = z.y;
  // Reset sliders
  const ls = document.getElementById('lsize');
  if(ls) ls.value = 60;
  const lsv = document.getElementById('lsizev');
  if(lsv) lsv.textContent = '60%';
  const lop = document.getElementById('lopac');
  if(lop) lop.value = 100;
  const lopv = document.getElementById('lopacv');
  if(lopv) lopv.textContent = '100%';
  // Reset file input
  const fileIn = document.getElementById('fileIn');
  if(fileIn) fileIn.value = '';
  // Hide file chip (lrow) + logo controls
  const lrow = document.getElementById('lrow');
  if(lrow) lrow.classList.remove('vis');
  const fileChip = document.getElementById('fileChip');
  if(fileChip) fileChip.style.display = 'none';
  const logoCtrl = document.getElementById('logoCtrl');
  if(logoCtrl) logoCtrl.style.display = 'none';
  // Show upload zone again
  const upzone = document.getElementById('upzone');
  if(upzone) upzone.style.display = '';
  // Redraw canvas (logo gone since S.logoImg is null)
  draw();
}
function updSize(el){S.lsize=+el.value;document.getElementById('lsizev').textContent=el.value+'%';draw();}
function updOpac(el){S.lopac=+el.value;document.getElementById('lopacv').textContent=el.value+'%';draw();}

function moveLogo(dx, dy){
  if(!S.logoImg) return;
  const z=getZone();
  // Calculate current logo dimensions
  const scale=S.lsize/100;
  let lw=z.w*scale;
  let lh=(S.logoImg.height/S.logoImg.width)*lw;
  if(lh>z.h*scale){lh=z.h*scale;lw=(S.logoImg.width/S.logoImg.height)*lh;}
  if(lw>z.w){lw=z.w;lh=(S.logoImg.height/S.logoImg.width)*lw;}
  if(lh>z.h){lh=z.h;lw=(S.logoImg.width/S.logoImg.height)*lh;}
  // Clamp within zone
  S.lx = Math.min(Math.max(S.lx + dx, z.x-z.w/2+lw/2), z.x+z.w/2-lw/2);
  S.ly = Math.min(Math.max(S.ly + dy, z.y-z.h/2+lh/2), z.y+z.h/2-lh/2);
  draw();
}

// ══════════════════════════════════════════
// PROMO
// ══════════════════════════════════════════
// ══════════════════════════════════════════
// EXTRAS / UPSELLS
// ══════════════════════════════════════════
S.extras = {
  qtyCollier: 100,
  qtyPaillesCarton: 100,
  qtyPaillesInox: 100,
  qtyComptoir: 1,
  qtyTournant: 1,
  qtyDistributeur: 1,
};
S.collierPerso = false; // Perso collier désactivée
S.designer = false;
S.designerNote = '';
S.designerCollier = false;
S.designerNoteCollier = '';
S.multiColor = false;

function toggleMultiColor(){
  S.multiColor = !S.multiColor;
  const btn = document.getElementById('togMultiColorBtn');
  const row = document.getElementById('togMultiColor');
  if(btn) btn.classList.toggle('on', S.multiColor);
  if(row){
    row.style.borderColor = S.multiColor ? 'var(--coral)' : 'var(--border)';
    row.style.background = S.multiColor ? '#FFF5F7' : 'var(--off)';
  }
}

function handleDesignerFilesMain(input){
  const newFiles = Array.from(input.files);
  if(!S.designerFilesMain) S.designerFilesMain = [];
  if(!S.designerFilesMainUrls) S.designerFilesMainUrls = [];
  newFiles.forEach(f => {
    if(!S.designerFilesMain.find(x => x.name === f.name)){
      S.designerFilesMain.push(f);
      // Upload Cloudinary
      uploadToCloudinary(f, 'brief_protection').then(url=>{
        if(url) S.designerFilesMainUrls.push({name: f.name, url});
      });
    }
  });
  const list = document.getElementById('designerFilesListMain');
  if(list) list.innerHTML = S.designerFilesMain.map((f, i) =>
    `<div style="display:flex;align-items:center;gap:6px;margin-top:4px">
      <span style="color:var(--coral)">📎</span>
      <span style="flex:1;font-size:.75rem">${f.name}</span>
      <span style="color:var(--muted);font-size:.7rem">${(f.size/1024).toFixed(0)} Ko</span>
      <button onclick="removeDesignerFileMain(${i})" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:.8rem;padding:0 2px">✕</button>
    </div>`
  ).join('');
  input.value = '';
}

function removeDesignerFileMain(idx){
  if(!S.designerFilesMain) return;
  S.designerFilesMain.splice(idx, 1);
  const list = document.getElementById('designerFilesListMain');
  if(list) list.innerHTML = S.designerFilesMain.map((f, i) =>
    `<div style="display:flex;align-items:center;gap:6px;margin-top:4px">
      <span style="color:var(--coral)">📎</span>
      <span style="flex:1;font-size:.75rem">${f.name}</span>
      <span style="color:var(--muted);font-size:.7rem">${(f.size/1024).toFixed(0)} Ko</span>
      <button onclick="removeDesignerFileMain(${i})" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:.8rem;padding:0 2px">✕</button>
    </div>`
  ).join('');
}

function handleDesignerFiles(input){
  const newFiles = Array.from(input.files);
  if(!S.designerFilesCollier) S.designerFilesCollier = [];
  if(!S.designerFilesCollierUrls) S.designerFilesCollierUrls = [];
  // Ajouter sans doublons (par nom)
  newFiles.forEach(f => {
    if(!S.designerFilesCollier.find(x => x.name === f.name)){
      S.designerFilesCollier.push(f);
      // Upload Cloudinary
      uploadToCloudinary(f, 'brief_collier').then(url=>{
        if(url) S.designerFilesCollierUrls.push({name: f.name, url});
      });
    }
  });
  const list = document.getElementById('designerFilesListCollier');
  if(list){
    list.innerHTML = S.designerFilesCollier.map((f, i) =>
      `<div style="display:flex;align-items:center;gap:6px;margin-top:4px">
        <span style="color:var(--coral)">📎</span>
        <span style="flex:1;font-size:.75rem">${f.name}</span>
        <span style="color:var(--muted);font-size:.7rem">${(f.size/1024).toFixed(0)} Ko</span>
        <button onclick="removeDesignerFile(${i})" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:.8rem;padding:0 2px">✕</button>
      </div>`
    ).join('');
  }
  // Reset input pour permettre re-sélection
  input.value = '';
}

function removeDesignerFile(idx){
  if(!S.designerFilesCollier) return;
  S.designerFilesCollier.splice(idx, 1);
  handleDesignerFiles({files:[]});
  // Rafraîchir l'affichage
  const list = document.getElementById('designerFilesListCollier');
  if(list){
    list.innerHTML = S.designerFilesCollier.map((f, i) =>
      `<div style="display:flex;align-items:center;gap:6px;margin-top:4px">
        <span style="color:var(--coral)">📎</span>
        <span style="flex:1;font-size:.75rem">${f.name}</span>
        <span style="color:var(--muted);font-size:.7rem">${(f.size/1024).toFixed(0)} Ko</span>
        <button onclick="removeDesignerFile(${i})" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:.8rem;padding:0 2px">✕</button>
      </div>`
    ).join('');
  }
}

function toggleDesigner(ctx){
  const key = ctx === 'collier' ? 'designerCollier' : 'designer';
  S[key] = !S[key];
  const suffix = ctx === 'collier' ? 'Collier' : 'Main';
  const block = document.getElementById('designerBlock'+(ctx==='collier'?'Collier':''));
  const tog = document.getElementById('togDesigner'+suffix);
  const comment = document.getElementById('designerComment'+suffix);
  if(block) block.classList.toggle('active', S[key]);
  if(tog) tog.classList.toggle('on', S[key]);
  if(comment) comment.style.display = S[key] ? 'flex' : 'none';
  if(comment) comment.style.flexDirection = 'column';
  if(S[key]){
    setTimeout(()=>{
      const ta = document.getElementById('designerNote'+suffix);
      if(ta) ta.focus();
    }, 100);
  }
}
S.collierCustomColor = false;
S.collierRow = [{ dy: 0, dx: 0 }, { dy: 0, dx: 0 }];

function renderCheckoutItems(){
  const el = document.getElementById('checkoutItems');
  if(!el) return;

  const imgs = {
    biberon:   'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/Design_sans_titre_29.png?v=1775448145',
    portecles: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte-cles-rose.webp?v=1775014619',
    chouchou:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/chouchou-noir_1.webp?v=1775028673',
    collier:   'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte_gobelet_mysafecup.webp?v=1775044215',
    paillesCarton:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/pailles_carton_noires.webp?v=1775037790',
    paillesInox:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/pailles_inox_mysafecup.webp?v=1775037787',
    comptoir:     'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-comptoir.webp?v=1775033881',
    tournant:     'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-tournant.webp?v=1775033884',
    distributeur: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-distributeur.webp?v=1775033869',
    kitRS:        'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/kit_communication_mysafecup.webp?v=1775043003',
  };

  function getProductImgData(){
    if(!S.perso || !S.logoImg) return null;
    try{
      const off=document.createElement('canvas'); off.width=500; off.height=500;
      const savedCtx=ctx; ctx=off.getContext('2d');
      window._skipZone=true;
      const savedStep=S.step; S.step=3;
      draw(); S.step=savedStep;
      window._skipZone=false; ctx=savedCtx;
      return off.toDataURL('image/png');
    }catch(e){ return null; }
  }

  function getCollierImgData(){
    if(!S.collierLogo) return null;
    try{ const cv=document.getElementById('cvCollier'); return cv?cv.toDataURL('image/png'):null; }
    catch(e){ return null; }
  }

  const prodImgData=getProductImgData();
  const collierImgData=getCollierImgData();

  const DESCS = {
    prodPerso: 'Protection anti-soumission chimique réutilisable. Personnalisé avec votre logo. '+(S.packaging==='kraft'?'Packaging Papier Kraft':'Packaging PVC Réutilisable')+' éco-responsable inclus.',
    prodStock: 'Protection anti-soumission chimique réutilisable. Logo My Safe Cup. '+(S.packaging==='kraft'?'Packaging Papier Kraft':'Packaging PVC Réutilisable')+' éco-responsable inclus.',
    customColor: 'Fabrication dans la couleur de votre choix au lieu des coloris standards.',
    multiColor: 'Impression en plusieurs couleurs pour un rendu fid\u00e8le \u00e0 votre identit\u00e9 visuelle.',
    designerProt: 'Un designer My Safe Cup crée votre visuel sur mesure et vous envoie un bon à tirer avant production.',
    designerCol: 'Un designer My Safe Cup crée votre visuel sur mesure sur collier et vous envoie un BAT avant production.',
    collierPerso: 'Collier confortable avec porte-gobelet extensible (s\'adapte a tous types de verres) — deux mains libres — Logo My Safe Cup — Personnalise avec votre logo.',
    collier: 'Collier confortable avec porte-gobelet extensible (s\'adapte a tous types de verres) — deux mains libres — Logo My Safe Cup.',
    paillesCarton: 'Pailles carton noires biodégradables. Conditionnées par pack de 100.',
    paillesInox: 'Pailles en inox réutilisables, brosses de nettoyage et étui inclus.',
    comptoir: 'Pr\u00e9sentoir compact id\u00e9al pour les comptoirs de bars et points de vente.',
    tournant: 'Plateau tournant 360\u00b0 \u00e0 3 faces — id\u00e9al pour boutiques et stands.',
    distributeur: 'Tiroir int\u00e9gr\u00e9 grande capacit\u00e9 — id\u00e9al pour festivals et discoth\u00e8ques.',
    kitRS: 'Profitez d\'une visibilité offerte sur nos réseaux sociaux (+90k abonnés) pour mettre en avant votre initiative. Notre CM vous contactera pour une communication sur mesure.',
    cadeauPreso: 'Idéal pour mettre en valeur vos protections de verre.',
    cadeauColliers: '50 colliers porte-gobelet confortables avec extensible (s\'adapte à tous types de verres) — deux mains libres — Logo My Safe Cup.',
    livraison: (S.perso||S.designer)?'Expédition en 15 à 20 jours ouvrés — numéro de suivi inclus.':'Expédition en 48/72H ouvrés — numéro de suivi inclus.',
  };

  // item éditable — avec contrôles de quantité
  // step: pas d'incrément (100 pour protections/colliers/pailles, 1 pour présentoirs)
  // minQty: minimum autorisé
  // onchange: callback JS string appelé avec la nouvelle valeur
  const itemEditable=(src,cover,name,desc,qty,pu,total,onInc,onDec,minQty=100,step=100,onDelete='')=>{
    const img = src
      ? `<img src="${src}" style="width:56px;height:56px;object-fit:${cover?'cover':'contain'};border-radius:8px;background:var(--off);flex-shrink:0">`
      : `<div style="width:56px;height:56px;border-radius:8px;background:var(--off);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:1.6rem">✏️</div>`;
    const hasQty = qty !== '' && qty !== null && onInc && onDec;
    const qtyCtrl = hasQty ? `<div style="display:flex;align-items:center;gap:0;border:1.5px solid var(--border);border-radius:8px;overflow:hidden;width:fit-content">
      <button onclick="${onDec}" style="background:none;border:none;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:1rem;cursor:pointer;color:var(--muted);transition:all .15s" onmouseover="this.style.background='var(--off)'" onmouseout="this.style.background='none'">−</button>
      <span style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.85rem;color:var(--dark);min-width:40px;text-align:center;padding:0 4px">${qty}</span>
      <button onclick="${onInc}" style="background:none;border:none;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:1rem;cursor:pointer;color:var(--muted);transition:all .15s" onmouseover="this.style.background='var(--off)'" onmouseout="this.style.background='none'">+</button>
    </div>` : '';
    const deleteBtn = onDelete ? `<button
        onclick="${onDelete}"
        title="Supprimer le produit"
        style="background:none;border:1.5px solid #E5E2DA;border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#bbb;font-size:.72rem;font-weight:700;transition:all .2s;flex-shrink:0;line-height:1"
        onmouseover="this.style.borderColor='var(--coral)';this.style.color='var(--coral)';this.style.background='#FFF5F7'"
        onmouseout="this.style.borderColor='#E5E2DA';this.style.color='#bbb';this.style.background='none'"
      >✕</button>` : '';
    return `<div style="display:flex;align-items:center;gap:12px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 14px">
      ${img}
      <div style="flex:1;min-width:0">
        <div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.88rem;color:var(--dark)">${name}</div>
        ${desc?`<div style="font-size:.72rem;color:var(--muted);margin-top:2px;line-height:1.4">${desc}</div>`:''}
      </div>
      <div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0">
        <div style="display:flex;align-items:center;gap:8px">
          ${qtyCtrl}
          ${deleteBtn}
        </div>
        <div style="font-size:.72rem;color:var(--muted);text-align:right">${parseFloat(pu).toFixed(2)} € / u</div>
        <div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:.95rem;color:var(--dark);text-align:right">${total}</div>
      </div>
    </div>`;
  };

  // item offert/fixe (cadeaux, livraison, designer) — sans contrôles
  const item=(src,cover,name,desc,qty,pu,total,badge='')=>{
    const img=`<img src="${src}" style="width:56px;height:56px;object-fit:${cover?'cover':'contain'};border-radius:8px;background:var(--off);flex-shrink:0">`;
    const right=badge
      ?`<span style="font-size:.65rem;font-weight:700;background:var(--teal);color:#fff;padding:3px 8px;border-radius:20px">${badge}</span>`
      :`<div style="text-align:right;flex-shrink:0;min-width:90px">${qty!==null?`<div style="font-size:.72rem;color:var(--muted)">${qty}\u00a0u\u00a0\u00d7\u00a0${parseFloat(pu).toFixed(2)}\u00a0\u20ac</div>`:''}<div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:1rem;color:var(--dark)">${total}</div></div>`;
    return `<div style="display:flex;align-items:center;gap:12px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 14px">${img}<div style="flex:1;min-width:0"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.88rem;color:var(--dark)">${name}</div>${desc?`<div style="font-size:.72rem;color:var(--muted);margin-top:2px">${desc}</div>`:''}</div>${right}</div>`;
  };

  const deleteX = (cb) => cb ? `<button onclick="${cb}" title="Supprimer" style="background:none;border:1.5px solid #E5E2DA;border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#bbb;font-size:.72rem;font-weight:700;transition:all .2s;flex-shrink:0;line-height:1" onmouseover="this.style.borderColor='var(--coral)';this.style.color='var(--coral)';this.style.background='#FFF5F7'" onmouseout="this.style.borderColor='#E5E2DA';this.style.color='#bbb';this.style.background='none'">✕</button>` : '';
  const dCard=(emoji,name,desc,price,onDelete='')=>`<div style="display:flex;align-items:center;gap:12px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 14px"><div style="width:56px;height:56px;border-radius:8px;background:var(--off);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:1.6rem">${emoji}</div><div style="flex:1;min-width:0"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.88rem;color:var(--dark)">${name}</div><div style="font-size:.72rem;color:var(--muted);margin-top:2px">${desc}</div></div><div style="display:flex;align-items:center;gap:8px;flex-shrink:0">${deleteX(onDelete)}<div style="text-align:right;min-width:70px"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:1rem;color:var(--dark)">${price}</div></div></div></div>`;

  const itemCadeau=(src,name,desc,onDelete,cover=false)=>`<div style="display:flex;align-items:center;gap:12px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 14px"><img src="${src}" style="width:56px;height:56px;object-fit:${cover?'cover':'contain'};border-radius:8px;background:var(--off);flex-shrink:0"><div style="flex:1;min-width:0"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.88rem;color:var(--dark)">${name}</div>${desc?`<div style="font-size:.72rem;color:var(--muted);margin-top:2px">${desc}</div>`:''}</div><div style="display:flex;align-items:center;gap:8px;flex-shrink:0"><span style="font-size:.65rem;font-weight:700;background:var(--teal);color:#fff;padding:3px 8px;border-radius:20px">Offert ✦</span>${deleteX(onDelete)}</div></div>`;

  const up=getUnitPrice(), q=S.qty;
  let total=0, html='';

  // Produit principal
  const prodTotal=up*q; total+=prodTotal;
  const prodColorLabel = (S.colorName && S.colorName!=='Transparent' && !S.customColor) ? ' — '+S.colorName : '';
  const prodMin = S.perso ? 500 : 200;
  html+=itemEditable(prodImgData||imgs[S.product],!!prodImgData,PNAMES[S.product]+prodColorLabel+(S.perso?' \u2014 Logo personnalis\u00e9':''),S.perso?DESCS.prodPerso:DESCS.prodStock,q,up,prodTotal.toFixed(2)+' \u20ac',
    `chkAdjQtyMain(${100})`,`chkAdjQtyMain(${-100})`,prodMin,100);

  // Couleur sur mesure
  if(S.customColor){const t=q*0.10;total+=t;html+=itemEditable(imgs[S.product],false,'Couleur sur mesure',DESCS.customColor,q,0.10,t.toFixed(2)+' \u20ac','','','','','','chkDelOption(\'customColor\')');}

  // Impression 2 couleurs
  if(S.multiColor){const t=q*0.05;total+=t;html+=itemEditable(imgs[S.product],false,'Impression 2 couleurs et +',DESCS.multiColor,q,0.05,t.toFixed(2)+' \u20ac','','','','','','chkDelOption(\'multiColor\')');}

  // Designer protections — GRATUIT
  if(S.designer){html+=`<div style="display:flex;align-items:center;gap:12px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 14px"><div style="width:56px;height:56px;border-radius:8px;background:var(--off);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:1.8rem">✏️</div><div style="flex:1;min-width:0"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.88rem;color:var(--dark)">Logo sur mesure — Designer My Safe Cup</div><div style="font-size:.72rem;color:var(--muted);margin-top:2px">${DESCS.designerProt}</div></div><div style="display:flex;align-items:center;gap:8px;flex-shrink:0"><span style="font-size:.65rem;font-weight:700;background:var(--teal);color:#fff;padding:3px 8px;border-radius:20px">Offert ✦</span>${deleteX(`chkDelOption('designer')`)}</div></div>`;}

  // Collier perso supprimé

  // Collier sans perso
  if(S.extras.collier&&S.extras.qtyCollier&&!S.collierPerso){
    const qC=S.extras.qtyCollier;
    const puC=getCollierBasePrice(qC);
    const tC=qC*puC;total+=tC;
    const collierColorLabelStd = S.collierCustomColor ? '' : (S.collierColor==='#1A1A1A'?' — Noir':S.collierColor==='#FFFFFF'?' — Blanc':' — Gris');
    html+=itemEditable(imgs.collier,false,'Collier Porte-gobelet'+collierColorLabelStd,DESCS.collier,qC,puC,tC.toFixed(2)+' \u20ac',
      `chkAdjCollier(100)`,`chkAdjCollier(-100)`,100,100,`chkDelExtra('collier')`);
  }

  // Pailles carton
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){
    const qP=S.extras.qtyPaillesCarton;
    const puP=getPaillesCartonPrice(qP);
    const tP=qP*puP;total+=tP;
    html+=itemEditable(imgs.paillesCarton,false,'Pailles Carton Noires',DESCS.paillesCarton,qP,puP,tP.toFixed(2)+' \u20ac',
      `chkAdjExtra('paillesCarton',100)`,`chkAdjExtra('paillesCarton',-100)`,100,100,`chkDelExtra('paillesCarton')`);
  }

  // Pailles inox
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){
    const qI=S.extras.qtyPaillesInox;
    const puI=getPaillesInoxPrice(qI);
    const tI=qI*puI;total+=tI;
    html+=itemEditable(imgs.paillesInox,false,'Pailles Inox R\u00e9utilisables',DESCS.paillesInox,qI,puI,tI.toFixed(2)+' \u20ac',
      `chkAdjExtra('paillesInox',100)`,`chkAdjExtra('paillesInox',-100)`,100,100,`chkDelExtra('paillesInox')`);
  }

  // Présentoirs payants
  [{key:'comptoir',name:'Pr\u00e9sentoir Comptoir'},{key:'tournant',name:'Pr\u00e9sentoir Tournant'},{key:'distributeur',name:'Pr\u00e9sentoir Distributeur'}]
  .forEach(({key,name})=>{
    if(S.extras[key]){
      const qPr=S.extras['qty'+key.charAt(0).toUpperCase()+key.slice(1)]||1;
      const tPr=qPr*25;total+=tPr;
      html+=itemEditable(imgs[key],false,name,DESCS[key],qPr,25,tPr.toFixed(2)+' \u20ac',
        `chkAdjPresentoir('${key}',1)`,`chkAdjPresentoir('${key}',-1)`,1,1,`chkDelExtra('${key}')`);
    }
  });

  // Cadeaux
  if(S.extras.cadeau_kitCom) html+=itemCadeau(imgs.kitRS,'Kit Communication R\u00e9seaux Sociaux',DESCS.kitRS,`chkDelCadeau('kitCom')`,true);
  if(S.extras.cadeau_presentoir){
    const pc=S.extras.presentoirChoisi||'distributeur';
    html+=itemCadeau(imgs[pc]||imgs.distributeur,'Pr\u00e9sentoir cadeau',DESCS.cadeauPreso,`chkDelCadeau('presentoir')`);
  }
  if(S.extras.cadeau_colliers) html+=itemCadeau(imgs.collier,'50 Colliers Porte-gobelet',DESCS.cadeauColliers,`chkDelCadeau('colliers')`);

  // Livraison toujours en dernier
  const livDesc=S.perso?'Personnalis\u00e9\u00a0: 15 \u00e0 20 jours ouvr\u00e9s':'Sur stock\u00a0: 2 \u00e0 3 jours ouvr\u00e9s';
  html+=`<div style="display:flex;align-items:center;gap:14px;background:var(--white);border:1.5px solid var(--border);border-radius:14px;padding:12px 16px"><div style="width:64px;height:64px;border-radius:8px;background:var(--off);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:1.8rem">\uD83D\uDE9A</div><div style="flex:1"><div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:.9rem;color:var(--dark)">Livraison</div><div style="font-size:.75rem;color:var(--muted);margin-top:2px">${livDesc}</div></div><span style="font-size:.65rem;font-weight:700;background:var(--teal);color:#fff;padding:3px 8px;border-radius:20px">Offert \u2736</span></div>`;

  // Remise
  const disc=S.promoDisc?total*S.promoDisc:0;
  const totalFinal=total-disc;
  const totalEl=document.getElementById('s_total');
  if(totalEl) totalEl.textContent=totalFinal.toFixed(2)+' \u20ac';
  const discRow=document.getElementById('s_disc_row');
  if(discRow) discRow.style.display=disc>0?'flex':'none';
  const discEl=document.getElementById('s_disc');
  if(discEl) discEl.textContent='\u2212'+disc.toFixed(2)+' \u20ac';

  // Date livraison estimée (jours ouvrés)
  const livEl = document.getElementById('s_livraison_date');
  if(livEl){
    const isPerso = S.perso || S.collierPerso;
    const jMin = isPerso ? 15 : 2;
    const jMax = isPerso ? 20 : 3;
    function addJoursOuvresLiv(date, jours){
      let count = 0; const d = new Date(date);
      while(count < jours){ d.setDate(d.getDate()+1); const day=d.getDay(); if(day!==0&&day!==6) count++; }
      return d;
    }
    const today = new Date();
    const dMin = addJoursOuvresLiv(today, jMin);
    const dMax = addJoursOuvresLiv(today, jMax);
    const fmt = d => d.toLocaleDateString('fr-FR', {day:'numeric', month:'short'});
    livEl.textContent = fmt(dMin) + ' – ' + fmt(dMax);
  }

  el.innerHTML=html;
}


(function(){
  let dragging = null;
  let lastY = 0;

  function getCollierCanvas(){ return document.getElementById('cvCollier'); }

  function canvasToRel(canvas, clientY){
    const r = canvas.getBoundingClientRect();
    return (clientY - r.top) / r.height; // 0..1
  }

  function nearestRow(relY){
    // Bande haute centrée à 0.435, bande basse à 0.565
    const d0 = Math.abs(relY - (0.435 + S.collierRow[0].dy));
    const d1 = Math.abs(relY - (0.565 + S.collierRow[1].dy));
    return d0 < d1 ? 0 : 1;
  }

  function attachCollierDrag(){
    const canvas = getCollierCanvas();
    if(!canvas || canvas._collierDragAttached) return;
    canvas._collierDragAttached = true;

    canvas.addEventListener('mousedown', e=>{
      if(!S.collierLogo) return;
      const relY = canvasToRel(canvas, e.clientY);
      dragging = nearestRow(relY);
      lastY = e.clientY;
      canvas.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', e=>{
      if(dragging === null) return;
      const canvas2 = getCollierCanvas();
      if(!canvas2) return;
      const r = canvas2.getBoundingClientRect();
      const dy = (e.clientY - lastY) / r.height;
      S.collierRow[dragging].dy = Math.max(-0.15, Math.min(0.15, S.collierRow[dragging].dy + dy));
      lastY = e.clientY;
      drawCollierCanvas();
    });

    window.addEventListener('mouseup', ()=>{
      if(dragging !== null){
        const canvas2 = getCollierCanvas();
        if(canvas2) canvas2.style.cursor = 'grab';
        dragging = null;
      }
    });

    canvas.style.cursor = 'grab';
  }

  // Attacher dès que le canvas est visible (step 6)
  const origGoStep = window.goStep;
  document.addEventListener('DOMContentLoaded', ()=>{
    const cvC = document.getElementById('cvCollier');
    if(cvC) attachCollierDrag();
  });
  setTimeout(()=>{ attachCollierDrag(); }, 1000);
})();

function moveCollierRow(rowIdx, dy, dx){
  if(dy !== 0) S.collierRow[rowIdx].dy = Math.max(-0.10, Math.min(0.10, S.collierRow[rowIdx].dy + dy * 0.001));
  if(dx === 'left')  S.collierRow[rowIdx].dx = Math.max(-0.10, S.collierRow[rowIdx].dx - 0.012);
  if(dx === 'right') S.collierRow[rowIdx].dx = Math.min(0.10,  S.collierRow[rowIdx].dx + 0.012);
  drawCollierCanvas();
}

function selCollierColorFixed(hex, name){
  if(hex === 'custom'){
    document.getElementById('ccolCollier').click();
    return;
  }
  S.collierColor = hex;
  S.collierCustomColor = false;
  ['Noir','Blanc','Gris','Custom'].forEach(n=>{
    const el = document.getElementById('swCollier'+n);
    if(el) el.style.boxShadow = 'none';
  });
  const id = name==='Sur mesure' ? 'swCollierCustom' : 'swCollier'+name;
  const el = document.getElementById(id);
  if(el) el.style.boxShadow = '0 0 0 2px #fff, 0 0 0 3.5px var(--coral)';
  const nameEl = document.getElementById('collierColorName');
  if(nameEl) nameEl.textContent = 'Couleur sélectionnée : '+name;
  // Changer l'image selon la couleur
  const colorKey = name.toLowerCase();
  if(colorKey === 'noir' || colorKey === 'blanc') loadCollierImg(colorKey);
  else loadCollierImg('gris');
}
S.collierLogo = null;
S.collierLx = 250; S.collierLy = 250; S.collierLsize = 80;

const COLLIER_IMGS = {
  noir:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/collier_noir.webp?v=1775222748',
  blanc: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/collier_blanc.webp?v=1775222746',
  gris:  'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/collier_pc_gris_sans_fond.webp?v=1775046735',
};
let _collierImg = null;

function loadCollierImg(colorKey){
  const url = COLLIER_IMGS[colorKey] || COLLIER_IMGS.gris;
  const img = new Image(); img.crossOrigin='anonymous';
  img.onload = ()=>{ _collierImg=img; drawCollierCanvas(); };
  img.onerror = ()=>{
    // Fallback gris
    const fb = new Image(); fb.crossOrigin='anonymous';
    fb.onload = ()=>{ _collierImg=fb; drawCollierCanvas(); };
    fb.src = COLLIER_IMGS.gris;
  };
  img.src = url;
}

// Charger image collier par défaut (noir)
loadCollierImg('noir');

function togglePersoCollier(){ /* supprimé */ }

function onExtrasNext(){
  calcSum(); updateDest();
  goStep(5);
}

function selCollierColor(input){
  S.collierColor = input.value;
  S.collierCustomColor = true;
  ['Noir','Blanc','Gris'].forEach(n=>{
    const el = document.getElementById('swCollier'+n);
    if(el) el.style.boxShadow = 'none';
  });
  const custom = document.getElementById('swCollierCustom');
  if(custom) custom.style.boxShadow = '0 0 0 2px #fff, 0 0 0 3.5px var(--coral)';
  const nameEl = document.getElementById('collierColorName');
  if(nameEl) nameEl.textContent = 'Couleur sélectionnée : Sur mesure ('+input.value+')';
  drawCollierCanvas();
}

function processLogoCollier(img){
  // Assigner directement — pas de traitement canvas intermédiaire
  // (évite les erreurs CORS liées au canvas collier)
  S.collierLogo = img;
  drawCollierCanvas();
}

function handleUploadCollier(event){
  const file = event.target.files[0]; if(!file) return;
  S.collierLogoFile = file;
  S.collierCloudUrl = null;
  // Upload Cloudinary en arrière-plan
  uploadToCloudinary(file, 'logo_collier').then(url=>{
    S.collierCloudUrl = url;
    if(url) console.log('Logo collier uploadé:', url);
  });
  const reader = new FileReader();
  reader.onload = e=>{
    const img = new Image();
    img.onload = ()=>{
      S.collierLogo = img;
      document.getElementById('lthumbCollier').src = e.target.result;
      document.getElementById('lfnCollier').textContent = file.name;
      document.getElementById('lrowCollier').style.display='flex';
      const acts = document.getElementById('collierActsWrap');
      if(acts) acts.style.display='flex';
      const msg=document.getElementById('designerMsg');
      if(msg) msg.style.display='block';
      drawCollierCanvas();
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
}

function removeLogoCollier(){
  S.collierLogo = null;
  S.collierRow = [{ dy: 0, dx: 0 }, { dy: 0, dx: 0 }];
  document.getElementById('fileInCollier').value='';
  document.getElementById('lrowCollier').style.display='none';
  const acts = document.getElementById('collierActsWrap');
  if(acts) acts.style.display='none';
  const msg=document.getElementById('designerMsg');
  if(msg) msg.style.display='none';
  drawCollierCanvas();
}

function dlCollierPreview(){
  const canvas = document.getElementById('cvCollier');
  if(!canvas) return;
  try{
    window._collierExporting = true;
    drawCollierCanvas();
    const link = document.createElement('a');
    link.download = 'mysafecup-collier-apercu.png';
    link.href = canvas.toDataURL('image/png');
    link.style.display='none';
    document.body.appendChild(link);
    link.click();
    setTimeout(()=>document.body.removeChild(link), 100);
    window._collierExporting = false;
    drawCollierCanvas();
    toast('⬇','Aperçu collier téléchargé !');
  }catch(e){ window._collierExporting=false; toast('❌','Erreur export'); }
}

function moveLogoCollier(dx, dy){
  S.collierLx += dx; S.collierLy += dy;
  drawCollierCanvas();
}

function drawCollierColorBadge(ctx2, c, W){
  const r = 104;
  const bx = W - r - 32;
  const by = r + 32;
  ctx2.save();
  ctx2.shadowColor='rgba(0,0,0,0.22)'; ctx2.shadowBlur=32; ctx2.shadowOffsetY=8;
  ctx2.beginPath(); ctx2.arc(bx, by, r, 0, Math.PI*2);
  ctx2.fillStyle = c; ctx2.fill();
  ctx2.shadowColor='transparent';
  ctx2.strokeStyle='rgba(255,255,255,0.95)'; ctx2.lineWidth=7;
  ctx2.beginPath(); ctx2.arc(bx, by, r, 0, Math.PI*2); ctx2.stroke();
  ctx2.textAlign='center'; ctx2.textBaseline='middle';
  ctx2.shadowColor='rgba(0,0,0,0.6)'; ctx2.shadowBlur=12;
  ctx2.fillStyle='#ffffff';
  ctx2.font='bold 22px DM Sans,sans-serif';
  ctx2.fillText('Votre couleur', bx, by-24);
  ctx2.fillText('sur mesure', bx, by+2);
  ctx2.font='20px DM Sans,sans-serif';
  ctx2.fillStyle='rgba(255,255,255,0.88)';
  ctx2.fillText(c.toUpperCase(), bx, by+28);
  ctx2.restore();
}

function drawCollierCanvas(){
  const canvas = document.getElementById('cvCollier');
  if(!canvas) return;
  const W = 1000, H = 1000;
  const ctx2 = canvas.getContext('2d');
  ctx2.clearRect(0,0,W,H);
  ctx2.fillStyle='#fff'; ctx2.fillRect(0,0,W,H);

  if(!_collierImg) return;

  const scale = W / _collierImg.width;
  const iw = _collierImg.width * scale;
  const ih = _collierImg.height * scale;
  const imgOffX = (W - iw) / 2;
  const imgOffY = (H - ih) / 2;
  ctx2.drawImage(_collierImg, imgOffX, imgOffY, iw, ih);

  // Zones calibrées des 2 bandes
  const zoneXStart = imgOffX + iw * 0.11;
  const zoneXEnd   = imgOffX + iw * 0.92;
  const zoneW = zoneXEnd - zoneXStart;
  const y1 = imgOffY + ih * 0.455; // bande haute
  const y2 = imgOffY + ih * 0.548; // bande basse
  const zH  = ih * 0.046;          // hauteur zone

  // Pointillés masqués (zones conservées pour placement des logos)
  // if(!window._collierExporting){
  //   ctx2.save();
  //   ctx2.setLineDash([12, 8]);
  //   ctx2.strokeStyle = 'rgba(210,100,0,0.7)';
  //   ctx2.lineWidth = 3;
  //   ctx2.strokeRect(zoneXStart, y1 - zH/2, zoneW, zH);
  //   ctx2.strokeRect(zoneXStart, y2 - zH/2, zoneW, zH);
  //   ctx2.setLineDash([]);
  //   ctx2.restore();
  // }

  if(!S.collierLogo) {
    // Pastille couleur sur mesure même sans logo
    if(S.collierCustomColor && S.collierColor){
      drawCollierColorBadge(ctx2, S.collierColor, W);
    }
    return;
  }

  // Logos répétés x5 sur chaque bande — taille fixe absolue (canvas 1000px)
  const ratio = S.collierLogo.width / S.collierLogo.height;
  const lh = 28; // px absolus sur canvas 1000px — ajusté pour tenir dans la bande
  const lw = lh * ratio;
  const n = 5;
  const gap = Math.max(4, (zoneW - n * lw) / (n + 1));

  [y1, y2].forEach(cy => {
    // Activer l'antialiasing pour qualité HD
    ctx2.imageSmoothingEnabled = true;
    ctx2.imageSmoothingQuality = 'high';
    for(let j = 0; j < n; j++){
      const x = zoneXStart + gap + j * (lw + gap);
      ctx2.drawImage(S.collierLogo, x, cy - lh/2, lw, lh);
    }
  });

  // Pastille couleur sur mesure par dessus
  if(S.collierCustomColor && S.collierColor){
    drawCollierColorBadge(ctx2, S.collierColor, W);
  }
}

const PRESENTOIR_DETAILS = {
  distributeur: {
    img: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-distributeur.webp?v=1775033869',
    desc: 'Idéal pour les festivals, discothèques et grands événements.'
  },
  comptoir: {
    img: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-comptoir.webp?v=1775033881',
    desc: 'Idéal pour les comptoirs de bars, restaurants et points de vente.'
  },
  tournant: {
    img: 'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-tournant.webp?v=1775033884',
    desc: 'Idéal pour les boutiques, espaces événementiels et stands.'
  },
};

function onSelectPresentoir(sel){
  S.extras.presentoirChoisi = sel.value;
  const data = PRESENTOIR_DETAILS[sel.value];
  if(!data) return;
  const img = document.getElementById('presentoirImg');
  const desc = document.getElementById('presentoirDesc');
  if(img) img.src = data.img;
  if(desc) desc.textContent = data.desc;
}

function toggleCadeau(key){
  // Bloquer présentoir et colliers si quantité < 1000
  if((key === 'presentoir' || key === 'colliers') && S.qty < 1000) return;
  S.extras['cadeau_'+key] = !S.extras['cadeau_'+key];
  const active = S.extras['cadeau_'+key];
  const capKey = key.charAt(0).toUpperCase()+key.slice(1);
  const btn = document.getElementById('tog'+capKey+'Btn');
  if(btn) btn.classList.toggle('on', active);
  const row = document.getElementById('tog'+capKey);
  if(row) row.classList.toggle('cadeau-active', active);
}

function toggleKitCom(){ toggleCadeau('kitCom'); }

function updatePresentoirOffert(){
  const offert = S.qty >= 1000;
  ['overlayPresentoir','overlayColliers'].forEach(id=>{
    const el = document.getElementById(id);
    if(el) el.classList.toggle('visible', !offert);
  });
  // Badge visible seulement si offert
  ['badgePresentoir','badgeColliers'].forEach(id=>{
    const el = document.getElementById(id);
    if(el){
      el.classList.toggle('hidden', !offert);
      el.classList.toggle('unlocked', offert);
    }
  });
  // Toggle disabled si pas offert — et décocher si nécessaire
  ['togPresentoir','togColliers'].forEach(id=>{
    const el = document.getElementById(id);
    if(el) el.classList.toggle('disabled', !offert);
  });
  if(!offert){
    ['presentoir','colliers'].forEach(key=>{
      if(S.extras['cadeau_'+key]){
        S.extras['cadeau_'+key] = false;
        const capKey = key.charAt(0).toUpperCase()+key.slice(1);
        const btn = document.getElementById('tog'+capKey+'Btn');
        if(btn) btn.classList.remove('on');
        const row = document.getElementById('tog'+capKey);
        if(row) row.classList.remove('cadeau-active');
      }
    });
  }
  // Classe locked sur les cartes verrouillées
  ['cadeauPresentoir','cadeauColliers'].forEach(id=>{
    const card = document.getElementById(id);
    if(card) card.classList.toggle('locked', !offert);
  });
  // Prix présentoirs payants
  ['Comptoir','Tournant','Distributeur'].forEach(name=>{
    const priceTag = document.getElementById('priceTag'+name);
    if(priceTag){ priceTag.textContent = '25,00 \u20ac HT / unit\u00e9'; priceTag.classList.remove('offert'); }
  });
  // Initialiser vignette présentoir
  const sel = document.getElementById('selectPresentoir');
  if(sel) onSelectPresentoir(sel);
  ['Presentoir','KitCom','Colliers'].forEach(name=>{
    const key = 'cadeau_'+name.charAt(0).toLowerCase()+name.slice(1);
    if(S.extras[key] === undefined) S.extras[key] = false;
    const btn = document.getElementById('tog'+name+'Btn');
    if(btn) btn.classList.toggle('on', !!S.extras[key]);
  });
  if(!S.extras.presentoirChoisi) S.extras.presentoirChoisi = 'distributeur';
}

function toggleExtra(key, el){
  // Comportement normal pour tous les extras — toggle simple
  S.extras[key] = !S.extras[key];
  el.classList.toggle('sel', S.extras[key]);
}

function updateCollierPersoBtn(){
  const qty = parseInt(document.getElementById('qtyCollier')?.value||0);
  const btn = document.getElementById('btnPersoCollier');
  if(!btn) return;
  const disabled = qty < 500;
  btn.style.opacity = disabled ? '.45' : '1';
  btn.style.cursor = disabled ? 'not-allowed' : 'pointer';
  // Si on redescend sous 500 et que la perso était activée → la désactiver
  if(false && S.collierPerso){
    S.collierPerso = false; // Perso collier désactivée
    const txt = document.getElementById('btnPersoCollierTxt');
    const check = document.getElementById('btnPersoCollierCheck');
    const nextBtn = document.getElementById('btnExtrasNext');
    const collierTab = document.getElementById('stepCollierTab');
    const snResume = document.getElementById('snResume');
    btn.style.background = 'var(--off)'; btn.style.borderColor = 'var(--border)'; btn.style.color = 'var(--dark)';
    if(check){ check.style.background='#fff'; check.style.borderColor='var(--border)'; check.textContent=''; }
    if(txt) txt.innerHTML = 'Personnaliser le collier +0,10 €/u <span style="font-weight:500;opacity:.7">(à partir de 500 u)</span>';
    if(nextBtn) nextBtn.textContent = 'Voir le résumé →';
    if(collierTab) collierTab.style.display = 'none';
    updateStepNumbers();
    calcSum();
    updateLivePrice();
  }
}

function adjExtraQty(key, delta){
  const inputId = 'qty'+key.charAt(0).toUpperCase()+key.slice(1);
  const input = document.getElementById(inputId);
  if(!input) return;
  const step = parseInt(input.step) || 1;
  const min = parseInt(input.min) || 1;
  const newVal = Math.max(min, (parseInt(input.value)||min) + delta);
  input.value = newVal;
  S.extras['qty'+key.charAt(0).toUpperCase()+key.slice(1)] = newVal;
  updateTierHighlight(input);
  if(key === 'collier') updateCollierPersoBtn();
}

function updateTierHighlight(input){
  const card = input.closest('.extra-card-v2');
  if(!card) return;
  const qty = parseInt(input.value) || 0;
  card.querySelectorAll('.collier-tier[data-min]').forEach(span=>{
    const min = parseInt(span.dataset.min);
    const max = parseInt(span.dataset.max);
    span.classList.toggle('active', qty >= min && qty <= max);
  });
}

// Init highlights on page load
document.addEventListener('DOMContentLoaded', ()=>{
  ['qtyCollier','qtyPaillesCarton','qtyPaillesInox'].forEach(id=>{
    const el = document.getElementById(id);
    if(el) updateTierHighlight(el);
  });
});

function applyPromo(){
  const code=document.getElementById('promoIn').value.trim().toUpperCase();
  const msg=document.getElementById('promoMsg');
  const inp=document.getElementById('promoIn');
  if(PROMO_CODES[code]!==undefined){
    S.promo=code;S.promoDisc=PROMO_CODES[code];
    inp.classList.add('ok');inp.classList.remove('err');
    msg.className='promo-msg ok';
    msg.textContent=`✓ Code appliqué — ${(S.promoDisc*100).toFixed(0)}% de remise !`;
    calcSum();toast('🎉',`Code ${code} appliqué !`);
  } else {
    S.promo=null;S.promoDisc=0;
    inp.classList.add('err');inp.classList.remove('ok');
    msg.className='promo-msg err';msg.textContent='✗ Code invalide ou expiré';
    calcSum();
  }
}

// ══════════════════════════════════════════
// PRICING — CORRIGÉ
// Le prix unitaire inclut déjà le logo
// Couleur sur mesure = +0,10€/u en plus
// ══════════════════════════════════════════
function getUnitPrice(){
  const q=S.qty;
  const tiers=TIERS[S.product]||[200,500,1000,2500,5000];
  // Find highest tier that is <= qty
  let tier=tiers[0];
  for(const t of tiers){ if(q>=t) tier=t; }
  const p=PRICES[S.product];
  const set=S.perso?p.logo:p.noLogo;
  return set[tier]||set[tiers[0]];
}
function getShip(){
  return 0; // Livraison toujours offerte
}

function updateDest(){
  const sel = document.getElementById('destSelect');
  if(!sel) return;
  const dest = sel.value;
  const label = document.getElementById('s_dest_label');
  if(label) label.textContent = dest;
  S.destination = dest;

  // Sync le champ Pays du modal
  const omPays = document.getElementById('omPays');
  if(omPays){
    const paysMap = {
      'France':'France',
      'Outre-Mer':'France (Outre-Mer)',
      'Belgique':'Belgique',
      'Suisse':'Suisse'
    };
    omPays.value = paysMap[dest] || dest;
  }

  calcSum();
}

// Sync inverse : quand omPays change, mettre à jour destSelect
function syncDestFromPays(val){
  const sel = document.getElementById('destSelect');
  if(!sel) return;
  const v = val.toLowerCase();
  if(v.includes('belgi')) sel.value = 'Belgique';
  else if(v.includes('suis')) sel.value = 'Suisse';
  else if(v.includes('outre') || v.includes('dom') || v.includes('reunion') || v.includes('martinique') || v.includes('guadeloupe') || v.includes('guyane') || v.includes('mayotte')) sel.value = 'Outre-Mer';
  else sel.value = 'France';
  updateDest();
}


function getCollierBasePrice(qty){
  return 0.80; // Prix fixe
}
function getPaillesCartonPrice(qty){
  if(qty>=1000) return 0.06;
  if(qty>=500)  return 0.08;
  return 0.10;
}
function getPaillesInoxPrice(qty){
  return 0.80; // Prix fixe
}
function calcSum(){
  const q=S.qty;
  const up=getUnitPrice();
  const colCost=S.customColor?q*0.10:0;
  const multiColorCost=S.multiColor?q*0.05:0;
  const designerCost=(0)+(0);
  const collierPersoCost=0; // Perso collier supprimée
  const ship=getShip();
  const display=q>=2500?'Offert ✦':'Non inclus';

  // Extras
  let extrasCost=0;
  if(S.extras.collier&&S.extras.qtyCollier&&!S.collierPerso){const puC=getCollierBasePrice(S.extras.qtyCollier);extrasCost+=S.extras.qtyCollier*puC;}
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){const puP=getPaillesCartonPrice(S.extras.qtyPaillesCarton);extrasCost+=S.extras.qtyPaillesCarton*puP;}
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){const puI=getPaillesInoxPrice(S.extras.qtyPaillesInox);extrasCost+=S.extras.qtyPaillesInox*puI;}
  ['comptoir','tournant','distributeur'].forEach(k=>{if(S.extras&&S.extras[k]){const qPr=S.extras['qty'+k.charAt(0).toUpperCase()+k.slice(1)]||1;extrasCost+=qPr*25;}});

  const prodCostCS = up*q;
  const discCS = S.promoDisc ? prodCostCS*S.promoDisc : 0;
  const subtotal=prodCostCS-discCS+colCost+multiColorCost+designerCost+ship+extrasCost;
  const disc=discCS;
  const total=subtotal;

  document.getElementById('s_prod').textContent=PNAMES[S.product];
  document.getElementById('s_color').textContent=S.colorName+(S.customColor?' (+0,10€/u)':'');
  document.getElementById('s_qty').textContent=q.toLocaleString('fr')+' unités';
  document.getElementById('s_unit').textContent=up.toFixed(2)+' € / u'+(S.perso?' (logo inclus)':'');
  document.getElementById('s_sub').textContent=(up*q).toFixed(2)+' €';
  const colRow=document.getElementById('s_col_row');
  colRow.style.display=S.customColor?'flex':'none';
  if(S.customColor)document.getElementById('s_col').textContent=colCost.toFixed(2)+' €';
  document.getElementById('s_display').textContent=display;
  document.getElementById('s_ship').textContent='Offert ✦';
  const drow=document.getElementById('s_disc_row');
  drow.style.display=disc?'flex':'none';
  if(disc){
    document.getElementById('s_disc_label').textContent=`Remise ${S.promo} (−${(S.promoDisc*100).toFixed(0)}% sur protections)`;
    document.getElementById('s_disc').textContent='−'+disc.toFixed(2)+' €';
  }
  document.getElementById('s_total').textContent=total.toLocaleString('fr',{minimumFractionDigits:0,maximumFractionDigits:0})+' €';
  // Lignes options
  const sMulti=document.getElementById('s_multicolor_row');
  if(sMulti) sMulti.style.display=S.multiColor?'flex':'none';
  if(S.multiColor&&document.getElementById('s_multicolor')) document.getElementById('s_multicolor').textContent=multiColorCost.toFixed(2)+' €';
  const sDesign=document.getElementById('s_designer_row');
  if(sDesign) sDesign.style.display=S.designer?'flex':'none';
  // s_designer_collier_row supprimé
  // s_collier_perso_row supprimé
  // Couleur sur mesure
  const sColRow=document.getElementById('s_col_row');
  if(sColRow) sColRow.style.display=S.customColor?'flex':'none';
  // Collier sans perso — masqué si collierPerso actif
  const sCollier=document.getElementById('s_collier_row');
  if(sCollier) sCollier.style.display=(S.extras.collier&&S.extras.qtyCollier&&!S.collierPerso)?'flex':'none';
  if(S.extras.collier&&S.extras.qtyCollier&&!S.collierPerso){
    const puC=getCollierBasePrice(S.extras.qtyCollier);
    const el=document.getElementById('s_collier');
    if(el) el.textContent=S.extras.qtyCollier+' u × '+puC.toFixed(2)+' € = '+(S.extras.qtyCollier*puC).toFixed(2)+' €';
  }
  // Pailles carton
  const sPaillesCarton=document.getElementById('s_pailles_carton_row');
  if(sPaillesCarton) sPaillesCarton.style.display=(S.extras.paillesCarton&&S.extras.qtyPaillesCarton)?'flex':'none';
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){
    const puP=getPaillesCartonPrice(S.extras.qtyPaillesCarton);
    const el=document.getElementById('s_pailles_carton');
    if(el) el.textContent=S.extras.qtyPaillesCarton+' u × '+puP.toFixed(2)+' € = '+(S.extras.qtyPaillesCarton*puP).toFixed(2)+' €';
  }
  // Pailles inox
  const sPaillesInox=document.getElementById('s_pailles_inox_row');
  if(sPaillesInox) sPaillesInox.style.display=(S.extras.paillesInox&&S.extras.qtyPaillesInox)?'flex':'none';
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){
    const puI=getPaillesInoxPrice(S.extras.qtyPaillesInox);
    const el=document.getElementById('s_pailles_inox');
    if(el) el.textContent=S.extras.qtyPaillesInox+' u × '+puI.toFixed(2)+' € = '+(S.extras.qtyPaillesInox*puI).toFixed(2)+' €';
  }
  // Présentoirs payants
  ['comptoir','tournant','distributeur'].forEach(key=>{
    const row=document.getElementById('s_preso_'+key+'_row');
    const qPr=S.extras['qty'+key.charAt(0).toUpperCase()+key.slice(1)]||1;
    const active=S.extras[key]&&qPr>0;
    if(row) row.style.display=active?'flex':'none';
    if(active){
      const el=document.getElementById('s_preso_'+key);
      if(el) el.textContent=qPr+' × 25,00 € = '+(qPr*25).toFixed(2)+' €';
    }
  });
  // Cadeaux
  const sKitRS=document.getElementById('s_kit_rs_row');
  if(sKitRS) sKitRS.style.display=S.extras.cadeau_kitCom?'flex':'none';
  const sCadeauPreso=document.getElementById('s_cadeau_preso_row');
  if(sCadeauPreso) sCadeauPreso.style.display=S.extras.cadeau_presentoir?'flex':'none';
  const sCadeauColliers=document.getElementById('s_cadeau_colliers_row');
  if(sCadeauColliers) sCadeauColliers.style.display=S.extras.cadeau_colliers?'flex':'none';
  if(document.getElementById('checkoutItems')) renderCheckoutItems();
  updateCadeauxResume();
}

// ══════════════════════════════════════════
// DOWNLOAD PREVIEW
// ══════════════════════════════════════════
function dlPreview(){
  // Render clean version on offscreen canvas (no dashed zone)
  const SIZE = 500;
  const dpr = window.devicePixelRatio || 1;
  const off = document.createElement('canvas');
  off.width = SIZE * dpr;
  off.height = SIZE * dpr;
  const offCtx = off.getContext('2d');
  offCtx.scale(dpr, dpr);

  // Swap ctx to offscreen, set skipZone flag, draw, then restore
  const savedCtx = ctx;
  ctx = offCtx;
  window._skipZone = true;
  draw();
  window._skipZone = false;
  ctx = savedCtx;
  draw(); // redraw main canvas normally

  // Download — lien attaché au DOM pour compatibilité tous navigateurs
  let dataUrl;
  try {
    dataUrl = off.toDataURL('image/png');
  } catch(e) {
    toast('❌','Erreur export (CORS) — réessayez');
    console.error('toDataURL error:', e);
    return;
  }
  const link = document.createElement('a');
  link.download = `mysafecup-apercu-${S.product}.png`;
  link.href = dataUrl;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => document.body.removeChild(link), 100);
  toast('⬇','Aperçu téléchargé !');
}

// ══════════════════════════════════════════
// PDF QUOTE — FORMAT DEVIS OFFICIEL MSC
// ══════════════════════════════════════════
async function genPDF(withOrder=false){
  toast('📄','Génération du devis…');
  await new Promise(r=>setTimeout(r,400));
  try{
    const {jsPDF}=window.jspdf;
    const doc=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
    const W=210, H=297, M=14;

    // ── Calculs tarifaires complets ──
    const up=getUnitPrice(), q=S.qty;
    const totalHT=calcTotalHT();
    const isOutreMer = S.destination === 'Outre-Mer';
    const tvaRate = isOutreMer ? 0 : 0.20;
    const tvaMt = totalHT * tvaRate;
    const totalTTC = totalHT + tvaMt;
    // Remise uniquement sur le produit principal
    const prodCostPDF = getUnitPrice() * S.qty;
    const disc = S.promoDisc ? prodCostPDF * S.promoDisc : 0;
    const devisNum = getCommandeRef(); // ref partagée
    const today=new Date();
    const fmtDate=d=>d.toLocaleDateString('fr-FR');
    const validity=new Date(today); validity.setDate(validity.getDate()+60);
    const delai=(S.perso||S.designer)?'15 à 20 jours ouvrés':'48/72H ouvrés';

    // ── Helpers ──
    const setFont=(style,size,r,g,b)=>{
      doc.setFont('helvetica',style);
      doc.setFontSize(size);
      doc.setTextColor(r??26,g??26,b??46);
    };
    const line=(y)=>{
      doc.setDrawColor(220,218,212);doc.setLineWidth(0.3);
      doc.line(M,y,W-M,y);
    };

    // ══ HEADER ══
    if(window._logoMainImg){
      const lc=document.createElement('canvas');lc.width=500;lc.height=120;
      const lx=lc.getContext('2d');
      lx.drawImage(window._logoMainImg,0,0,500,120);
      doc.addImage(lc.toDataURL('image/png'),'PNG',M,8,52,13);
    } else {
      setFont('bold',18,26,26,46);
      doc.text('MY SAFE CUP',M,20);
    }

    let y=26;
    setFont('normal',8,80,80,95);
    doc.text('386 Quai Marcel Pagnol',M,y);y+=4.5;
    doc.text('83000 Toulon — France',M,y);y+=5.5;
    setFont('bold',8,26,26,46);
    doc.text('Votre contact : Mathis Grauliere',M,y);y+=4.5;
    setFont('normal',8,80,80,95);
    doc.text('WhatsApp : +33 6 59 38 30 28',M,y);y+=4.5;
    doc.text('Email : contact@mysafecup.co',M,y);

    const rx=W/2+2;
    setFont('bold',9,26,26,46);
    doc.text('Devis '+devisNum,rx,26);
    setFont('normal',8,80,80,95);
    doc.text('En date du : '+fmtDate(today),rx,31);
    doc.text('Valable jusqu\'au : '+fmtDate(validity),rx,36);
    setFont('normal',7,26,26,200);
    doc.text('Consulter nos CGV : mysafecup.co/pages/cgv',rx,41);
    doc.link(rx, 38, 80, 5, {url:'https://mysafecup.co/pages/cgv', newWindow: true});

    line(54);

    // ══ BLOC CLIENT — deux colonnes ══
    y=66;
    const ci = S.contactInfo || {};
    const halfW = (W-2*M-4)/2;
    const colL = M;
    const colR = M+halfW+4;
    const maxAddrW = halfW - 26; // largeur dispo pour le texte adresse

    // Pré-calcul wrapping adresse
    setFont('normal',8,26,26,46);
    const addrLines = doc.splitTextToSize(ci.adresse||'________________________________', maxAddrW);
    const addrExtraH = Math.max(0, (addrLines.length - 1) * 5);

    // Hauteur droite dynamique selon nb lignes adresse + complement
    const baseRightH = ci.complement ? 50 : 43;
    const rightBlockH = baseRightH + addrExtraH;
    const leftBlockH = 40;
    const maxBlockH = Math.max(leftBlockH, rightBlockH);

    // Colonne gauche — À l'attention de
    doc.setFillColor(248,247,244);
    doc.roundedRect(colL, y, halfW, leftBlockH, 2, 2, 'F');
    setFont('bold',9,26,26,46);
    doc.text('A l\'attention de :', colL+3, y+7);
    setFont('normal',8,26,26,46);
    doc.text('Societe :      '+(ci.soc||'________________________________'), colL+3, y+14);
    doc.text('Contact :      '+((ci.pre||'')+(ci.nom?' '+ci.nom:'')||'________________________________'), colL+3, y+21);
    doc.text('Email :          '+(ci.mail||'________________________________'), colL+3, y+28);
    doc.text('Telephone :  '+(ci.tel||'________________________________'), colL+3, y+35);

    // Colonne droite — Adresse de livraison (hauteur dynamique)
    doc.setFillColor(248,247,244);
    doc.roundedRect(colR, y, halfW, rightBlockH, 2, 2, 'F');
    setFont('bold',9,26,26,46);
    doc.text('Adresse de livraison :', colR+3, y+7);
    setFont('normal',8,26,26,46);
    // Label fixe + texte wrappé
    doc.text('Adresse :', colR+3, y+14);
    doc.text(addrLines, colR+24, y+14);
    let ry = y + 14 + addrExtraH;
    if(ci.complement){ doc.text('Complement :  '+ci.complement, colR+3, ry+7); ry+=7; }
    doc.text('Ville :               '+(ci.ville||'________________________________'), colR+3, ry+7);
    doc.text('Code postal :  '+(ci.codePostal||'________________________________'), colR+3, ry+14);
    doc.text('Pays :              '+(ci.pays||'________________________________'), colR+3, ry+21);

    // Ligne séparatrice et tableau basés sur le bloc le plus grand + marge
    line(y + maxBlockH + 5);

    // ══ TABLEAU ══
    y = 66 + maxBlockH + 5 + 8;

    // Colonnes : Remise et PU Final seulement si code promo actif
    const hasPromo = !!(S.promoDisc && S.promoDisc > 0);

    // Positions colonnes sur toute la largeur de la page
    const cols = hasPromo ? {
      desc: M,
      qty:  108,
      puHT: 124,
      rem:  138,
      puFin:153,
      tHT:  168,
      tva:  182,
      tTTC: W-M,
    } : {
      desc: M,
      qty:  118,
      puHT: 138,
      rem:  null,
      puFin:null,
      tHT:  163,
      tva:  179,
      tTTC: W-M,
    };

    // Header couleur F2BE1A
    doc.setFillColor(242,190,26);
    doc.rect(M,y-5,W-2*M,10,'F');
    setFont('bold',8,26,26,46);
    doc.text('Nom du produit / Ref',cols.desc+2,y+1);
    doc.text('Qte',cols.qty,y+1,'right');
    doc.text('PU HT',cols.puHT,y+1,'right');
    if(hasPromo){
      doc.text('Remise',cols.rem,y+1,'right');
      doc.text('PU Final',cols.puFin,y+1,'right');
    }
    doc.text('Total HT',cols.tHT,y+1,'right');
    doc.text('TVA',cols.tva,y+1,'right');
    doc.text('Total TTC',cols.tTTC,y+1,'right');
    y+=8;

    const pkgLabel = S.packaging === 'kraft' ? 'Packaging Papier Kraft' : 'Packaging PVC Reutilisable';
    const colorDesc = 'Couleur : '+S.colorName+(S.customColor?' (sur mesure)':'')+'.'
    const productDesc={
      biberon:'Safe Cup lavable et reutilisable au format biberon.'+(S.perso?' Personnalise avec votre logo.':' Logo My Safe Cup.')+' '+colorDesc+' Matiere en silicone alimentaire. Anti-intrusion et anti-renversement. S\'adapte a tous types de verres (O 5-10 cm). Avec ou sans paille. '+pkgLabel+' eco-responsable inclus.',
      portecles:'Safe Cup lavable et reutilisable au format porte-cles.'+(S.perso?' Personnalise avec votre logo.':' Logo My Safe Cup.')+' '+colorDesc+' Matiere en nylon impermeable et extensible. S\'adapte a tous types de verres. Conditionnement unitaire avec anneau.',
      chouchou:'Safe Cup lavable et reutilisable au format chouchou.'+(S.perso?' Personnalise avec votre logo.':' Logo My Safe Cup.')+' '+colorDesc+' Matiere en nylon impermeable et extensible. S\'adapte a tous types de verres (O 5-10 cm). Packaging Velvet en carton inclus.',
    };
    const productRef={biberon:'SC_BIB',portecles:'SC_PKL',chouchou:'SC_CHC'};
    const persoSuffix=S.perso?' — Logo personnalisé':'';
    const colorSuffix=' — '+S.colorName+(S.customColor?' (sur mesure)':'');

    const drawRow=(ref,name,desc,qty,puHT,remisePct,rowIdx)=>{
      const safeDesc = (desc||'').replace(/\n/g,' ').replace(/\\n/g,' - ');
      const bg=rowIdx%2===0?[255,255,255]:[249,248,245];
      doc.setFillColor(...bg);
      const descLines=doc.splitTextToSize(safeDesc,cols.qty-cols.desc-4);
      const rh=Math.max(16,descLines.length*3.8+10);

      // Saut de page si nécessaire
      if(y + rh > H - 30){
        doc.addPage();
        y = 20;
      }

      doc.setFillColor(...bg);
      doc.rect(M,y-2,W-2*M,rh,'F');

      // Réf en gras + nom produit
      setFont('bold',8.5,26,26,46);
      doc.text(name,cols.desc+2,y+4);
      setFont('normal',5.5,140,140,155);
      doc.text(ref,cols.desc+2,y+8);
      setFont('normal',6.5,100,100,115);
      doc.text(descLines,cols.desc+2,y+12);

      // Calculs
      const remDec = remisePct/100;
      const puFinal = puHT*(1-remDec);
      const totHT = typeof qty==='number' ? puFinal*qty : 0;
      const totTTC = totHT*(1+tvaRate);

      setFont('normal',7.5,26,26,46);
      if(typeof qty==='number') doc.text(qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '),cols.qty,y+5,'right');
      else doc.text(String(qty),cols.qty,y+5,'right');

      if(puHT>0){
        doc.text(puHT.toFixed(2)+' €',cols.puHT,y+5,'right');
        if(hasPromo && cols.rem){
          doc.text(remisePct>0?remisePct.toFixed(0)+'%':'—',cols.rem,y+5,'right');
          doc.text(puFinal.toFixed(2)+' €',cols.puFin,y+5,'right');
        }
        setFont('bold',7.5,26,26,46);
        doc.text(totHT.toFixed(2)+' €',cols.tHT,y+5,'right');
        setFont('normal',7.5,26,26,46);
        doc.text((tvaRate*100).toFixed(0)+'%',cols.tva,y+5,'right');
        setFont('bold',7.5,26,26,46);
        doc.text(totTTC.toFixed(2)+' €',cols.tTTC,y+5,'right');
      } else {
        doc.text('—',cols.puHT,y+5,'right');
        if(hasPromo && cols.rem){
          doc.text('—',cols.rem,y+5,'right');
          doc.text('—',cols.puFin,y+5,'right');
        }
        setFont('bold',7.5,26,26,46);
        doc.text('OFFERT',cols.tHT,y+5,'right');
        setFont('normal',7.5,26,26,46);
        doc.text('—',cols.tva,y+5,'right');
        setFont('bold',7.5,26,26,46);
        doc.text('OFFERT',cols.tTTC,y+5,'right');
      }
      y+=rh+1;
    };

    // ══ LIGNES — payants du plus cher au moins cher, offerts en bas ══
    const descProd = productDesc[S.product]+(S.customColor?'\nCouleur sur mesure incluse':'');
    const remisePct = S.promoDisc ? S.promoDisc*100 : 0;
    const pdfRows = [];
    const addRow = (ref,name,desc,qty,pu,remPct,offered=false) => {
      const puFinal = pu*(1-(remPct/100));
      const totalHT = typeof qty==='number' ? puFinal*qty : 0;
      pdfRows.push({ref,name,desc,qty,pu,remPct,offered,totalHT});
    };

    // Produit principal
    const pdfProdColorLabel = (S.colorName && S.colorName!=='Transparent' && !S.customColor) ? ' — '+S.colorName : '';
    addRow(productRef[S.product]+persoSuffix+colorSuffix, PNAMES[S.product]+pdfProdColorLabel+(S.perso?' — Logo personnalise':''), descProd, q, up, remisePct);

    // Collier perso supprimé

    // Collier sans perso
    if(S.extras.collier && S.extras.qtyCollier && !S.collierPerso){
      const qC=S.extras.qtyCollier;
      const puC=getCollierBasePrice(qC);
      addRow('SC_COLLIER','Collier Porte-gobelet'+(S.collierCustomColor?'':S.collierColor==='#1A1A1A'?' — Noir':S.collierColor==='#FFFFFF'?' — Blanc':' — Gris'),'Collier confortable avec porte-gobelet extensible (s\'adapte a tous types de verres) — deux mains libres — Logo My Safe Cup. Couleur : '+(S.collierCustomColor?S.collierColor+' (sur mesure)':S.collierColor==='#1A1A1A'?'Noir':S.collierColor==='#FFFFFF'?'Blanc':'Gris')+'.',qC,puC,0);
    }

    // Presentoirs payants
    [{key:'comptoir',ref:'PRES_CPT',name:'Presentoir Comptoir',desc:'Ideal pour les comptoirs de bars, restaurants et points de vente.',pu:25},
     {key:'tournant',ref:'PRES_TRN',name:'Presentoir Tournant',desc:'Ideal pour les boutiques, espaces evenementiels et stands.',pu:25},
     {key:'distributeur',ref:'PRES_DST',name:'Presentoir Distributeur',desc:'Ideal pour les festivals, discoteques et grands evenements.',pu:25}
    ].forEach(({key,ref,name,desc,pu})=>{
      if(S.extras[key]){
        const qPr=S.extras['qty'+key.charAt(0).toUpperCase()+key.slice(1)]||1;
        addRow(ref,name,desc,qPr,pu,0);
      }
    });

    // Logo sur mesure protections — GRATUIT
    if(S.designer){
      const dNote = S.designerNote ? '\nInstructions : '+S.designerNote : '';
      addRow('OPT_DESIGN','Logo sur mesure - Protections — Offert','Un designer My Safe Cup cree votre visuel sur mesure et vous envoie un bon a tirer avant production.'+dNote,1,0,0,true);
    }

    // Designer collier supprimé

    // Pailles inox
    if(S.extras.paillesInox && S.extras.qtyPaillesInox){
      const qI=S.extras.qtyPaillesInox;
      const puI=getPaillesInoxPrice(qI);
      addRow('PAILLE_INOX','Pailles Inox Reutilisables','Pailles en inox reutilisables. Brosses de nettoyage et etui inclus.',qI,puI,0);
    }

    // Couleur sur mesure
    if(S.customColor) addRow('OPT_COLOR','Option couleur sur mesure','Surcharge couleur sur mesure (+0,10 EUR / unite)',q,0.10,0);

    // Impression 2 couleurs
    if(S.multiColor) addRow('OPT_MULTI','Impression 2 couleurs et +','Surcharge impression multicolore (+0,05 EUR / unite)',q,0.05,0);

    // Pailles carton
    if(S.extras.paillesCarton && S.extras.qtyPaillesCarton){
      const qP=S.extras.qtyPaillesCarton;
      const puP=getPaillesCartonPrice(qP);
      addRow('PAILLE_CARTON','Pailles Carton Noires','Pailles carton noires biodegradables. Conditionnees par pack de 100.',qP,puP,0);
    }

    // ── OFFERTS (toujours en bas) ──
    if(S.extras.cadeau_kitCom)
      addRow('KIT_RS','Kit Communication Reseaux Sociaux','Profitez d\'une visibilite offerte sur nos reseaux sociaux (+90k abonnes) pour mettre en avant votre initiative. Notre CM vous contactera pour une communication sur mesure.',1,0,0,true);

    if(S.extras.cadeau_presentoir){
      const pc=S.extras.presentoirChoisi||'distributeur';
      const pn={distributeur:'Presentoir Distributeur',comptoir:'Presentoir Comptoir',tournant:'Presentoir Tournant'};
      const pd={distributeur:'Ideal pour les festivals, discoteques et grands evenements.',comptoir:'Ideal pour les comptoirs de bars, restaurants et points de vente.',tournant:'Ideal pour les boutiques, espaces evenementiels et stands.'};
      addRow('PRES_CADEAU',pn[pc]+' - Offert',pd[pc],1,0,0,true);
    }

    if(S.extras.cadeau_colliers)
      addRow('COL_CADEAU','50 Colliers Porte-gobelet - Offerts','Collier confortable avec porte-gobelet extensible (s\'adapte a tous types de verres) — deux mains libres — Logo My Safe Cup.',50,0,0,true);

    // Livraison toujours en dernier
    const livNom = {
      'France': 'Livraison France Metropolitaine',
      'Outre-Mer': 'Livraison Outre-Mer (DOM-TOM)',
      'Belgique': 'Livraison Belgique',
      'Suisse': 'Livraison Suisse',
    }[S.destination] || 'Livraison';
    addRow('LIV','Livraison — '+livNom,'Expedition en '+delai+' — Numero de suivi inclus.','1',0,0,true);

    // Trier : payants par totalHT decroissant, offerts a la fin
    const payants = pdfRows.filter(r=>!r.offered).sort((a,b)=>b.totalHT-a.totalHT);
    const offerts = pdfRows.filter(r=>r.offered);
    const sortedRows = [...payants, ...offerts];

    // Dessiner les lignes
    sortedRows.forEach((r,i)=>drawRow(r.ref,r.name,r.desc,r.qty,r.pu,r.remPct,i));

    y+=2;
    line(y); y+=5;

    // Saut de page avant totaux si besoin (section totaux ~ 80mm)
    if(y > H - 70){ doc.addPage(); y = 20; }

    // ══ TOTAUX ══
    const totW=80, totX=W-M-totW;

    // ── Encadré Notes (à gauche des totaux, si rempli) ──
    if(ci.msg){
      const notesX = M;
      const notesW = totX - M - 8;
      const notesLines = doc.splitTextToSize(ci.msg, notesW - 8);
      const notesH = Math.max(28, notesLines.length * 4.5 + 12);
      const notesY = y - 4;
      doc.setFillColor(248,247,244);
      doc.roundedRect(notesX, notesY, notesW, notesH, 2, 2, 'F');
      doc.setDrawColor(200,198,192);
      doc.setLineWidth(0.3);
      doc.roundedRect(notesX, notesY, notesW, notesH, 2, 2, 'S');
      setFont('bold',7.5,26,26,46);
      doc.text('Notes :', notesX+4, notesY+7);
      setFont('normal',7,80,80,95);
      doc.text(notesLines, notesX+4, notesY+13);
    }
    const totRow=(lbl,val,bold=false)=>{
      if(bold){
        doc.setFillColor(26,26,46);
        doc.roundedRect(totX-2,y-4,totW+2+M,10,2,2,'F');
        setFont('bold',10,255,255,255);
        doc.text(lbl,totX,y+3);
        doc.setTextColor(255,214,0);
        doc.text(val,W-M,y+3,'right');
      } else {
        setFont('normal',8.5,80,80,95);
        doc.text(lbl,totX,y);
        setFont('bold',8.5,26,26,46);
        doc.text(val,W-M,y,'right');
      }
      y+=bold?12:6;
    };

    if(disc) totRow('Remise '+S.promo+' (-'+(S.promoDisc*100).toFixed(0)+'% sur protections)','-'+disc.toFixed(2)+' €');
    totRow('Total net HT',totalHT.toFixed(2)+' €');
    totRow('TVA ('+(tvaRate*100).toFixed(0)+'%)',tvaMt.toFixed(2)+' €');
    totRow('Total TTC',totalTTC.toFixed(2)+' €',true);

    // Note TVA alignée sous le Total TTC
    const tvaNote = isOutreMer
      ? 'TVA non applicable - regime Outre-Mer (art. 294 du CGI).'
      : 'TVA de 20 % applicable conformement a l\'article 289 du Code general des impots.';
    setFont('normal',6.5,120,120,140);
    doc.text(tvaNote, totX-2, y+1, {maxWidth: totW+M+2});
    y += 10;

    // ══ MOYENS DE PAIEMENT — juste après les totaux ══
    y+=3;
    if(y > H - 30){ doc.addPage(); y = 20; }
    const totalCentimes = Math.round(totalTTC * 100);
    const cartUrl = `https://mysafecup.co/cart/${SHOPIFY_VARIANT_ID}:${totalCentimes}`;
    const pageUrl = `https://mysafecup.co/pages/commande-b2b?ref=${encodeURIComponent(devisNum)}&ht=${encodeURIComponent(totalHT.toFixed(2))}&ttc=${encodeURIComponent(totalTTC.toFixed(2))}&perso=${S.perso||S.collierPerso?'1':'0'}&cart=${encodeURIComponent(cartUrl)}${ci.pre?'&contact='+encodeURIComponent(ci.pre+' '+ci.nom):''}${ci.soc?'&soc='+encodeURIComponent(ci.soc):''}`;
    const shopifyUrl = pageUrl;

    if(y > H - 80){ doc.addPage(); y = 20; }
    setFont('bold',10,26,26,46);
    doc.text('Confirmer votre commande des maintenant - Moyens de paiement :',M,y); y+=4;

    const colW = (W-2*M-6)/2;
    const col1X = M;
    const col2X = M+colW+6;

    const boxH = 68;

    // ── Colonne 1 : Virement bancaire ──
    doc.setFillColor(235,248,243);
    doc.roundedRect(col1X, y, colW, boxH, 3, 3, 'F');
    doc.setDrawColor(0,160,100);
    doc.setLineWidth(0.5);
    doc.roundedRect(col1X, y, colW, boxH, 3, 3, 'S');

    // Titre
    setFont('bold',10,0,120,70);
    doc.text('Virement bancaire', col1X+5, y+8);

    // Encadré descriptif juste sous le titre
    doc.setFillColor(200,238,220);
    doc.roundedRect(col1X+4, y+12, colW-8, 10, 1.5, 1.5, 'F');
    setFont('bold',9,0,0,0);
    doc.text('Commande traitee a la reception du virement.', col1X+colW/2, y+18.5, 'center');

    // Coordonnées bancaires
    setFont('normal',9,0,0,0);
    doc.text('Beneficiaire : SAS MY SAFE CUP', col1X+5, y+27);
    doc.text('IBAN : FR76 1910 6000 0844 7096 1576 686', col1X+5, y+34);
    doc.text('BIC : AGRIFRPP891', col1X+5, y+41);
    doc.text('Banque : Credit Agricole', col1X+5, y+48);
    setFont('bold',9,180,0,0);
    doc.text('Reference obligatoire : '+devisNum, col1X+5, y+55);
    setFont('normal',9,0,0,0);

    // ── Colonne 2 : Carte bancaire ──
    doc.setFillColor(235,248,243);
    doc.roundedRect(col2X, y, colW, boxH, 3, 3, 'F');
    doc.setDrawColor(0,160,100);
    doc.setLineWidth(0.5);
    doc.roundedRect(col2X, y, colW, boxH, 3, 3, 'S');

    // Titre
    setFont('bold',10,0,120,70);
    doc.text('Paiement par carte bancaire', col2X+5, y+8);

    // Encadré descriptif juste sous le titre
    doc.setFillColor(200,238,220);
    doc.roundedRect(col2X+4, y+12, colW-8, 10, 1.5, 1.5, 'F');
    setFont('bold',9,0,0,0);
    doc.text('Commande traitee instantanement.', col2X+colW/2, y+18.5, 'center');

    // Description
    setFont('normal',9,0,0,0);
    doc.text('Paiement instantane et securise via notre site officiel.', col2X+5, y+27);
    doc.text('Vous serez redirige vers mysafecup.co pour finaliser.', col2X+5, y+34);

    // Bouton cliquable vert
    doc.setFillColor(0,160,100);
    doc.roundedRect(col2X+4, y+42, colW-8, 12, 2, 2, 'F');
    setFont('bold',10,255,255,255);
    doc.text('Payer ma commande en ligne', col2X+colW/2, y+49.5, 'center');
    doc.link(col2X+4, y+42, colW-8, 12, {url: shopifyUrl});

    y += boxH + 6;

    // ── Encadré À SAVOIR — saut de page automatique si manque de place ──
    const asavoirH = 30;
    if(y + asavoirH + 30 > H - 15){ doc.addPage(); y = 20; }
    doc.setFillColor(26,26,46);
    doc.roundedRect(M, y, W-2*M, asavoirH, 3, 3, 'F');

    // Titre "À savoir"
    setFont('bold',9,255,200,60);
    doc.text('A savoir :', M+6, y+7);

    // Ligne intro
    setFont('bold',8,255,255,255);
    doc.text('Une fois la commande validee, notre equipe vous contactera avec la facture.', M+6, y+14);

    // Ligne stock — label + texte collés
    setFont('bold',7.5,80,220,140);
    doc.text('Commande sur stock :', M+6, y+21);
    setFont('normal',7.5,210,210,210);
    doc.text('Votre commande sera directement traitee et un numero de suivi vous sera envoye.', M+40, y+21);

    // Ligne perso — label + texte collés
    setFont('bold',7.5,80,180,255);
    doc.text('Commande personnalisee :', M+6, y+27);
    setFont('normal',7.5,210,210,210);
    doc.text('Les designs a valider vous seront envoyes avant le lancement de la production.', M+48, y+27);

    y += asavoirH + 5;
    line(y); y += 5;

    // ══ FOOTER SUR TOUTES LES PAGES + NUMÉROTATION ══
    const totalPages = doc.getNumberOfPages();
    for(let p = 1; p <= totalPages; p++){
      doc.setPage(p);
      const footerY = H - 10;
      doc.setFillColor(240,239,236);
      doc.rect(0, footerY-5, W, 15, 'F');
      setFont('normal',7,100,100,110);
      doc.text(
        'My Safe Cup — 386 Quai Marcel Pagnol — 83000 Toulon — France  |  SIRET : 933 163 065 00016  |  NAF : 4791A  |  TVA : FR46933163065  |  RCS Toulon  |  Capital : 10 000 €',
        W/2, footerY, 'center'
      );
      doc.text('WhatsApp : +33 6 59 38 30 28  —  contact@mysafecup.co  —  mysafecup.co', W/2, footerY+4, 'center');
      // Numérotation page X/Y en haut à droite
      setFont('normal',7,160,160,170);
      doc.text('Page '+p+' / '+totalPages, W-M, 8, 'right');
    }

    // Capturer le PDF en base64 pour la pièce jointe email
    const pdfBase64 = doc.output('datauristring').split(',')[1];
    const pdfFilename = 'MySafeCup-Devis-'+devisNum+'-'+S.qty+'u.pdf';

    // Téléchargement via blob URL — compatible Shopify et navigateurs stricts
    const pdfBlob = doc.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);
    const dlLink = document.createElement('a');
    dlLink.href = blobUrl;
    dlLink.download = pdfFilename;
    dlLink.style.display = 'none';
    document.body.appendChild(dlLink);
    dlLink.click();
    setTimeout(()=>{ document.body.removeChild(dlLink); URL.revokeObjectURL(blobUrl); }, 1000);

    if(withOrder){
      // Envoyer email en arrière-plan
      toast('📧','Envoi du récapitulatif…');
      const totalHTVal = calcTotalHT();
      const ci = S.contactInfo || {};

      // Bloc contact si disponible
      const contactBlock = ci.pre ? `
  <h3 style="margin:0 0 12px;color:#1a1a2e;font-size:15px;border-bottom:3px solid #f2be1a;padding-bottom:7px">👤 Informations client</h3>
  <table style="width:100%;border-collapse:collapse;font-size:14px;margin-bottom:8px">
    <tr>
      <td style="width:50%;vertical-align:top;padding-right:12px">
        <div style="background:#f8f7f4;border-radius:8px;padding:12px 14px">
          <div style="font-weight:700;color:#1a1a2e;margin-bottom:8px;font-size:13px">Contact</div>
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <tr><td style="padding:3px 0;color:#666;width:40%">Nom</td><td><strong>${ci.pre} ${ci.nom}</strong></td></tr>
            <tr><td style="padding:3px 0;color:#666">Société</td><td>${ci.soc||'—'}</td></tr>
            <tr><td style="padding:3px 0;color:#666">Email</td><td><a href="mailto:${ci.mail}" style="color:#00a064">${ci.mail}</a></td></tr>
            <tr><td style="padding:3px 0;color:#666">Téléphone</td><td>${ci.tel||'—'}</td></tr>
            ${ci.type?`<tr><td style="padding:3px 0;color:#666">Type</td><td>${ci.type}</td></tr>`:''}
            ${ci.date?`<tr><td style="padding:3px 0;color:#666">Événement</td><td>${ci.date}</td></tr>`:''}
          </table>
        </div>
      </td>
      <td style="width:50%;vertical-align:top">
        <div style="background:#f8f7f4;border-radius:8px;padding:12px 14px">
          <div style="font-weight:700;color:#1a1a2e;margin-bottom:8px;font-size:13px">Adresse de livraison</div>
          ${ci.adresse ? `
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <tr><td style="padding:3px 0;color:#666;width:40%">Adresse</td><td>${ci.adresse}</td></tr>
            ${ci.complement?`<tr><td style="padding:3px 0;color:#666">Complément</td><td>${ci.complement}</td></tr>`:''}
            <tr><td style="padding:3px 0;color:#666">Ville</td><td>${ci.ville}</td></tr>
            <tr><td style="padding:3px 0;color:#666">Code postal</td><td>${ci.codePostal}</td></tr>
            <tr><td style="padding:3px 0;color:#666">Pays</td><td>${ci.pays}</td></tr>
          </table>` : '<span style="color:#999;font-size:13px">Non renseignée</span>'}
        </div>
      </td>
    </tr>
  </table>
  ${ci.msg?`<div style="background:#fff3cd;border-radius:8px;padding:10px 14px;font-size:13px;margin-top:4px"><strong>📝 Notes :</strong> ${ci.msg}</div>`:''}
  ` : '';

      const message = buildEmailHTML(devisNum, totalHTVal.toFixed(2), totalTTC.toFixed(2), [], contactBlock);

      try{
        const subject = ci.soc
          ? `[MSC B2B] Nouvelle commande — ${devisNum} — ${ci.soc}`
          : `[MSC B2B] Nouvelle commande — ${devisNum}`;
        const pdfAttachment = [{content: pdfBase64, name: pdfFilename}];

        // Email interne (Mathis)
        await sendBrevoEmail(subject, message, pdfAttachment);

        // Email client avec devis en PJ
        if(ci.mail){
          const clientSubject = `Votre devis My Safe Cup — ${devisNum}`;
          const clientHTML = buildClientEmail(devisNum, ci, totalHTVal.toFixed(2), totalTTC.toFixed(2));
          await sendBrevoEmailTo(clientSubject, clientHTML, [{email:ci.mail, name:`${ci.pre} ${ci.nom}`}], pdfAttachment);

          // Ajouter le contact dans la liste Brevo pour relances
          await addBrevoContact(ci, devisNum, totalHTVal.toFixed(2));
        }

        toast('✅','Devis généré ! Redirection...');
        setTimeout(()=>{ window.location.href = shopifyUrl; }, 500);
      }catch(e){
        console.error('Brevo error:', e);
        toast('✅','Devis généré !');
      }

      // Email unique via Brevo avec buildEmailHTML

    } else {
      toast('✅','Devis PDF téléchargé !');
    }
  }catch(e){
    console.error('PDF ERROR:', e);
    toast('❌','Erreur: '+e.message);
  }
}

// ══════════════════════════════════════════
// ORDER MODAL
// ══════════════════════════════════════════
// Stocker le mode (withOrder) globalement pour submitOrderModal
let _modalWithOrder = true;

async function openOrderModal(withOrder=true){
  _modalWithOrder = withOrder;
  // Réinitialiser le formulaire
  ['omPrenom','omNom','omSoc','omEmail','omTel','omAdresse','omComplement','omVille','omCodePostal','omDate','omNotes'].forEach(id=>{
    const el=document.getElementById(id); if(el) el.value='';
  });
  const sel=document.getElementById('omType'); if(sel) sel.value='';
  const err=document.getElementById('omError'); if(err) err.style.display='none';
  const btn=document.getElementById('omSubmitBtn');
  if(btn){
    btn.disabled=false;
    btn.innerHTML = withOrder ? '🛒 Générer mon devis & commander' : '📄 Générer le devis PDF';
  }
  // Ouvrir
  const overlay=document.getElementById('orderModalOverlay');
  if(overlay){ overlay.style.display='flex'; document.body.style.overflow='hidden'; }
}

function closeOrderModal(){
  const overlay=document.getElementById('orderModalOverlay');
  if(overlay){ overlay.style.display='none'; document.body.style.overflow=''; }
}

async function submitOrderModal(){
  const pre=document.getElementById('omPrenom')?.value.trim();
  const nom=document.getElementById('omNom')?.value.trim();
  const soc=document.getElementById('omSoc')?.value.trim();
  const mail=document.getElementById('omEmail')?.value.trim();
  const tel=document.getElementById('omTel')?.value.trim();
  const adresse=document.getElementById('omAdresse')?.value.trim();
  const complement=document.getElementById('omComplement')?.value.trim();
  const ville=document.getElementById('omVille')?.value.trim();
  const codePostal=document.getElementById('omCodePostal')?.value.trim();
  const pays=document.getElementById('omPays')?.value.trim();
  const date=document.getElementById('omDate')?.value;
  const type=document.getElementById('omType')?.value;
  const msg=document.getElementById('omNotes')?.value.trim();

  const err=document.getElementById('omError');
  const btn=document.getElementById('omSubmitBtn');

  // Validation
  if(!pre||!nom||!soc||!mail||!tel||!adresse||!ville||!codePostal||!pays){
    if(err){ err.textContent='Veuillez remplir tous les champs obligatoires (*)'; err.style.display='block'; }
    return;
  }
  if(!/\S+@\S+\.\S+/.test(mail)){
    if(err){ err.textContent='Adresse email invalide.'; err.style.display='block'; }
    return;
  }
  if(err) err.style.display='none';
  if(btn){ btn.disabled=true; btn.innerHTML='⏳ Génération en cours…'; }

  closeOrderModal();
  resetCommandeRef();

  S.contactInfo = {pre, nom, soc, mail, tel, adresse, complement, ville, codePostal, pays, date, type, msg};

  await genPDF(_modalWithOrder);
}

function chkConfirmDelete(btn, onDelete){
  // Fermer tous les autres popovers ouverts
  document.querySelectorAll('.del-confirm').forEach(el=>{
    if(el !== btn.nextElementSibling) el.style.display='none';
  });
  const confirm = btn.nextElementSibling;
  if(confirm) confirm.style.display = confirm.style.display==='none' ? 'block' : 'none';
}

function chkCancelDelete(btn){
  const confirm = btn.closest('.del-confirm');
  if(confirm) confirm.style.display='none';
}

// Fermer les popovers si on clique ailleurs
document.addEventListener('click', e=>{
  if(!e.target.closest('.del-confirm') && !e.target.closest('[onclick*="chkConfirmDelete"]')){
    document.querySelectorAll('.del-confirm').forEach(el=>el.style.display='none');
  }
});

function chkDelCadeau(key){
  S.extras['cadeau_'+key] = false;
  // Effacer la mémoire de restauration si suppression manuelle
  if(S._cadeauxSaved) S._cadeauxSaved['cadeau_'+key] = false;
  const capKey = key.charAt(0).toUpperCase()+key.slice(1);
  const btn = document.getElementById('tog'+capKey+'Btn');
  if(btn) btn.classList.remove('on');
  const row = document.getElementById('tog'+capKey);
  if(row) row.classList.remove('cadeau-active');
  calcSum();
}

function adjExtraQtyCard(key, delta){
  const inpId = key==='collier' ? 'qtyCollierResume' : 'qtyPaillesInoxResume';
  const inp = document.getElementById(inpId);
  if(!inp) return;
  const newVal = Math.max(100, Math.round(((parseInt(inp.value)||100) + delta) / 100) * 100);
  inp.value = newVal;
  if(key === 'collier') S.extras.qtyCollier = newVal;
  else if(key === 'paillesInox') S.extras.qtyPaillesInox = newVal;
  calcSum();
}

function toggleExtraCheckoutCard(key){
  const cardIds = {collier:'extraCollierResume', paillesInox:'extraPaillesInoxResume', presentoir:'extraPresentoirResume'};
  const qtyIds = {collier:'collierResumeQtyBlock', paillesInox:'paillesInoxResumeQtyBlock', presentoir:'presentoirResumeQtyBlock'};
  const card = document.getElementById(cardIds[key]);
  const isOn = card && card.classList.toggle('sel');
  // Style visuel
  if(card){
    card.style.borderColor = isOn ? 'var(--coral)' : 'var(--border)';
    card.style.background = isOn ? '#FFF5F7' : 'var(--white)';
  }
  const qtyBlock = document.getElementById(qtyIds[key]);
  if(qtyBlock) qtyBlock.style.display = isOn ? 'block' : 'none';
  if(key === 'collier'){
    S.extras.collier = isOn;
    if(isOn){ S.extras.qtyCollier = parseInt(document.getElementById('qtyCollierResume')?.value||100)||100; }
    else { S.extras.qtyCollier = 100; }
  } else if(key === 'paillesInox'){
    S.extras.paillesInox = isOn;
    if(isOn){ S.extras.qtyPaillesInox = parseInt(document.getElementById('qtyPaillesInoxResume')?.value||100)||100; }
    else { S.extras.qtyPaillesInox = 100; }
  } else if(key === 'presentoir'){
    const type = document.getElementById('presoTypeResume')?.value || 'distributeur';
    ['comptoir','tournant','distributeur'].forEach(k => { S.extras[k] = false; });
    if(isOn){
      S.extras[type] = true;
      S.extras.presentoirChoisi = type;
      S.extras['qty'+type.charAt(0).toUpperCase()+type.slice(1)] = parseInt(document.getElementById('qtyPresentoirResume')?.value||1)||1;
    }
  }
  calcSum();
}

function toggleExtraCheckout(key, checked){
  // legacy — redirige vers la nouvelle fonction carte
  toggleExtraCheckoutCard(key);
}

function updateCadeauxResume(){
  const offert = S.qty >= 1000;
  const section = document.getElementById('cadeauxResumeSection');
  if(!section) return;

  const items = [
    {key:'kitCom',     label:'Kit Communication\nRéseaux Sociaux', desc:'Visibilité offerte sur nos réseaux (+90k abonnés) — notre CM vous contacte', img:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/kit_communication_mysafecup.webp?v=1775043003', always:true,  badge:'Offert', seuil:0},
    {key:'colliers',   label:'50 Colliers\nPorte-gobelet',         desc:'Collier confortable avec porte-gobelet extensible — deux mains libres',       img:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/porte_gobelet_mysafecup.webp?v=1775044215', always:false, badge:'Offert dès 500 unités',  seuil:500},
    {key:'presentoir', label:'Présentoir\nDistributeur',            desc:'Idéal pour mettre en valeur vos protections de verre en point de vente',     img:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-distributeur.webp?v=1775033869', always:false, badge:'Offert dès 1 000 unités', seuil:1000},
  ];

  const list = document.getElementById('cadeauxResumeList');
  if(!list) return;

  list.innerHTML = items.map(item => {
    const offertItem = item.always || S.qty >= (item.seuil||1000);
    const locked = !offertItem;
    const checked = !!S.extras['cadeau_'+item.key];
    const border = checked ? '2px solid var(--teal)' : '2px solid var(--border)';
    const bg = checked ? '#F0FBF8' : 'var(--white)';
    const badgeStyle = locked
      ? 'font-size:.68rem;font-weight:800;background:#1A1A2E;color:#fff;padding:5px 10px;border-radius:20px;white-space:nowrap;letter-spacing:.2px'
      : 'font-size:.62rem;font-weight:700;background:var(--teal);color:#fff;padding:3px 8px;border-radius:20px;white-space:nowrap';
    const badgeText = item.badge;
    const cursor = locked ? 'default' : 'pointer';
    const clickAttr = locked ? '' : 'onclick="toggleCadeauResume(\'' + item.key + '\')"';
    return '<div ' + clickAttr + ' style="border:' + border + ';border-radius:16px;padding:14px;background:' + bg + ';display:flex;flex-direction:column;align-items:center;gap:7px;text-align:center;transition:all .2s;cursor:' + cursor + '">'
      + '<img src="' + item.img + '" style="width:80px;height:80px;object-fit:' + (item.key==='kitCom'?'cover':'contain') + ';border-radius:10px;background:var(--off)">'
      + '<div style="font-family:Bricolage Grotesque,sans-serif;font-weight:700;font-size:.82rem;color:var(--dark);line-height:1.3">' + item.label.replace('\n','<br>') + '</div>'
      + '<div style="font-size:.66rem;color:var(--muted);line-height:1.4">' + item.desc + '</div>'
      + '<span style="' + badgeStyle + '">' + badgeText + '</span>'
      + '<label style="display:flex;align-items:center;gap:6px;cursor:' + cursor + ';margin-top:2px" onclick="event.stopPropagation()">'
        + '<input type="checkbox" ' + (checked?'checked':'') + ' ' + (locked?'disabled':'') + ' onchange="toggleCadeauResume(\'' + item.key + '\')" style="accent-color:var(--teal);width:15px;height:15px;cursor:' + cursor + '">'
        + '<span style="font-size:.72rem;font-weight:600;color:' + (locked?'var(--muted)':'var(--dark)') + '">' + (locked?'Disponible dès 1 000 unités':'Je souhaite en bénéficier') + '</span>'
      + '</label>'
      + '</div>';
  }).join('');
}

function toggleCadeauResume(key){
  const seuilMap = {colliers:500, presentoir:1000};
  if(seuilMap[key] && S.qty < seuilMap[key]) return;
  S.extras['cadeau_'+key] = !S.extras['cadeau_'+key];
  updateCadeauxResume();
  calcSum();
}

function adjExtraQtyResume(key, delta){
  const inp = document.getElementById('qtyPresentoirResume');
  if(!inp) return;
  const newVal = Math.max(1, (parseInt(inp.value)||1) + delta);
  inp.value = newVal;
  const type = document.getElementById('presoTypeResume')?.value || 'comptoir';
  S.extras['qty'+type.charAt(0).toUpperCase()+type.slice(1)] = newVal;
  calcSum();
}

function onPresentoirQtyResume(inp){
  const newVal = Math.max(1, parseInt(inp.value)||1);
  inp.value = newVal;
  const type = document.getElementById('presoTypeResume')?.value || 'comptoir';
  S.extras['qty'+type.charAt(0).toUpperCase()+type.slice(1)] = newVal;
  calcSum();
}

function onPresoResumeChange(sel){
  const imgs = {comptoir:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-comptoir.webp?v=1775033881',tournant:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-tournant.webp?v=1775033884',distributeur:'https://cdn.shopify.com/s/files/1/0568/7551/6071/files/presentoir-distributeur.webp?v=1775033869'};
  const thumb = document.getElementById('presoThumbResume');
  if(thumb) thumb.src = imgs[sel.value] || imgs.comptoir;
  const card = document.getElementById('extraPresentoirResume');
  if(card && card.classList.contains('sel')){
    ['comptoir','tournant','distributeur'].forEach(k => { S.extras[k] = false; });
    S.extras[sel.value] = true;
    S.extras.presentoirChoisi = sel.value;
    calcSum();
  }
}

function chkDelOption(key){
  if(key === 'customColor'){
    S.customColor = false;
    S.color = S.product === 'biberon' ? 'transparent' : '#1A1A1A';
    S.colorName = S.product === 'biberon' ? 'Transparent' : 'Noir';
    document.querySelectorAll('.sw').forEach(s=>s.classList.remove('sel'));
    const first = document.querySelector('.sw');
    if(first){ first.classList.add('sel'); }
  } else if(key === 'multiColor'){
    S.multiColor = false;
    const tog = document.getElementById('togMultiColorBtn');
    if(tog) tog.classList.remove('on');
    const row = document.getElementById('togMultiColor');
    if(row) row.classList.remove('on');
  } else if(key === 'designer'){
    S.designer = false;
    const tog = document.getElementById('togDesignerMain');
    if(tog) tog.classList.remove('on');
    const block = document.getElementById('designerBlock');
    if(block) block.classList.remove('active');
    const comment = document.getElementById('designerCommentMain');
    if(comment) comment.style.display = 'none';
  } else if(key === 'designerCollier'){
    S.designerCollier = false;
    const tog = document.getElementById('togDesignerCollier');
    if(tog) tog.classList.remove('on');
    const block = document.getElementById('designerBlockCollier');
    if(block) block.classList.remove('active');
    const comment = document.getElementById('designerCommentCollier');
    if(comment) comment.style.display = 'none';
  }
  calcSum();
}
function chkDelDesigner(type){
  if(type==='main'){
    S.designer = false;
    const tog = document.getElementById('togDesignerMain');
    if(tog) tog.classList.remove('on');
    const block = document.getElementById('designerBlock');
    if(block) block.classList.remove('active');
  } else {
    S.designerCollier = false;
    const tog = document.getElementById('togDesignerCollier');
    if(tog) tog.classList.remove('on');
    const block = document.getElementById('designerBlockCollier');
    if(block) block.classList.remove('active');
  }
  calcSum();
}

function chkDelMultiColor(){
  S.multiColor = false;
  const tog = document.getElementById('togMultiColorBtn');
  if(tog) tog.classList.remove('on');
  const row = document.getElementById('togMultiColor');
  if(row) row.classList.remove('on');
  calcSum();
}

function chkDelCustomColor(){
  S.customColor = false;
  S.color = S.product==='biberon' ? 'transparent' : '#1A1A1A';
  S.colorName = S.product==='biberon' ? 'Transparent' : 'Noir';
  // Remettre la sélection sur le premier swatch
  document.querySelectorAll('.sw').forEach(sw=>sw.classList.remove('sel'));
  const first = document.querySelector('.sw');
  if(first) first.classList.add('sel');
  draw();
  calcSum();
}

function chkDelExtra(key){
  if(key === 'collierPerso'){
    S.collierPerso = false; // Perso collier désactivée
    const btn = document.getElementById('btnPersoCollier');
    const txt = document.getElementById('btnPersoCollierTxt');
    const check = document.getElementById('btnPersoCollierCheck');
    const collierTab = document.getElementById('stepCollierTab');
    const nextBtn = document.getElementById('btnExtrasNext');
    if(btn){ btn.style.background='var(--off)'; btn.style.borderColor='var(--border)'; btn.style.color='var(--dark)'; }
    if(check){ check.style.background='#fff'; check.style.borderColor='var(--border)'; check.textContent=''; }
    if(txt) txt.innerHTML = 'Personnaliser le collier +0,10 €/u <span style="font-weight:500;opacity:.7">(à partir de 500 u)</span>';
    if(nextBtn) nextBtn.textContent = 'Voir le résumé →';
    if(collierTab) collierTab.style.display = 'none';
    updateStepNumbers();
  } else if(key === 'collier'){
    S.extras.collier = false;
    const card = document.getElementById('extraCollier');
    if(card) card.classList.remove('sel');
  } else if(key === 'paillesCarton'){
    S.extras.paillesCarton = false;
    const card = document.getElementById('extraPaillesCarton');
    if(card) card.classList.remove('sel');
  } else if(key === 'paillesInox'){
    S.extras.paillesInox = false;
    const card = document.getElementById('extraPaillesInox');
    if(card) card.classList.remove('sel');
  } else if(['comptoir','tournant','distributeur'].includes(key)){
    S.extras[key] = false;
    const card = document.getElementById('extra'+key.charAt(0).toUpperCase()+key.slice(1));
    if(card) card.classList.remove('sel');
  }
  calcSum();
}

function showCadeauxSupprimes(){
  const el = document.getElementById('cadeauxSupprimesNotif');
  if(!el) return;
  el.style.display = 'flex';
  clearTimeout(el._hideTimer);
  el._hideTimer = setTimeout(()=>{ el.style.display='none'; }, 4000);
}

// Réinitialise la mémoire de restauration pour une clé donnée (suppression manuelle)
function clearCadeauSaved(key){
  if(S._cadeauxSaved) S._cadeauxSaved['cadeau_'+key] = false;
}
function chkAdjQtyMain(delta){
  const minQty = S.perso ? 500 : 200;
  const newQty = Math.max(minQty, Math.round((S.qty + delta) / 100) * 100);
  S.qty = newQty;
  // Sync champ qty step 2
  const inp = document.getElementById('qtyInput');
  if(inp) inp.value = newQty;
  // Si cadeaux nécessitent 1000+ et on passe en dessous, les décocher avec notif
  if(newQty < 1000){ // vérif globale — détail par seuil dans la boucle
    let cadeauxRetires = false;
    const seuilsCadeaux = {colliers:500, presentoir:1000};
    ['colliers','presentoir'].forEach(key=>{
      if(S.extras['cadeau_'+key] && newQty < (seuilsCadeaux[key]||1000)){
        // Mémoriser l'état avant suppression
        if(!S._cadeauxSaved) S._cadeauxSaved = {};
        S._cadeauxSaved['cadeau_'+key] = true;
        S.extras['cadeau_'+key] = false;
        cadeauxRetires = true;
        const capKey = key.charAt(0).toUpperCase()+key.slice(1);
        const btn = document.getElementById('tog'+capKey+'Btn');
        if(btn) btn.classList.remove('on');
        const row = document.getElementById('tog'+capKey);
        if(row) row.classList.remove('cadeau-active');
      }
    });
    if(cadeauxRetires) showCadeauxSupprimes();
  } else {
    // Repasse au-dessus de 1000 — restaurer les cadeaux mémorisés
    if(S._cadeauxSaved){
      let cadeauxRestaures = false;
      const seuilsRestore = {colliers:500, presentoir:1000};
      ['colliers','presentoir'].forEach(key=>{
        if(S._cadeauxSaved['cadeau_'+key] && S.qty >= (seuilsRestore[key]||1000)){
          S.extras['cadeau_'+key] = true;
          cadeauxRestaures = true;
          const capKey = key.charAt(0).toUpperCase()+key.slice(1);
          const btn = document.getElementById('tog'+capKey+'Btn');
          if(btn) btn.classList.add('on');
          const row = document.getElementById('tog'+capKey);
          if(row) row.classList.add('cadeau-active');
        }
      });
      if(cadeauxRestaures){
        S._cadeauxSaved = null;
        toast('🎁','Cadeaux restaurés !');
      }
    }
  }
  updateTiers();
  calcSum();
}

function chkAdjCollier(delta){
  const minQty = S.collierPerso ? 500 : 100;
  const newQty = Math.max(minQty, Math.round(((S.extras.qtyCollier||100) + delta) / 100) * 100);
  S.extras.qtyCollier = newQty;
  const inp = document.getElementById('qtyCollier');
  if(inp){ inp.value = newQty; updateTierHighlight(inp); }
  updateCollierPersoBtn();
  calcSum();
}

function chkAdjExtra(key, delta){
  const qKey = 'qty'+key.charAt(0).toUpperCase()+key.slice(1);
  const current = S.extras[qKey] || 100;
  const newQty = Math.max(100, Math.round((current + delta) / 100) * 100);
  S.extras[qKey] = newQty;
  const inp = document.getElementById('qty'+key.charAt(0).toUpperCase()+key.slice(1));
  if(inp){ inp.value = newQty; updateTierHighlight(inp); }
  calcSum();
}

function chkAdjPresentoir(key, delta){
  const qKey = 'qty'+key.charAt(0).toUpperCase()+key.slice(1);
  const current = S.extras[qKey] || 1;
  const newQty = Math.max(1, current + delta);
  S.extras[qKey] = newQty;
  const inp = document.getElementById('qty'+key.charAt(0).toUpperCase()+key.slice(1));
  if(inp) inp.value = newQty;
  calcSum();
}

// ══════════════════════════════════════════
// BUILD EMAIL HTML — fonction centralisée MSC
// ══════════════════════════════════════════
function buildEmailHTML(ref, totalHT, totalTTC, extraOpts=[], contactBlock=''){
  const q = S.qty;
  const up = getUnitPrice();

  // ── Ligne produit principal ──
  const prodRows = [];
  prodRows.push({label:'Produit', val:`<strong>${PNAMES[S.product]}</strong>`});
  prodRows.push({label:'Référence', val: ({'biberon':'SC-BIB',portecles:'SC-PKL',chouchou:'SC-CHC'}[S.product]||S.product)+(S.perso?' — Logo personnalisé':'')});
  prodRows.push({label:'Couleur', val: S.customColor
    ? `${S.color.toUpperCase()} <span style="display:inline-block;width:12px;height:12px;border-radius:50%;background:${S.color};border:1px solid #ccc;vertical-align:middle;margin-left:4px"></span> <span style="background:#fff3cd;padding:1px 6px;border-radius:4px;font-size:12px">Sur mesure</span>`
    : S.colorName});
  prodRows.push({label:'Quantité', val:`<strong>${q.toLocaleString('fr')} unités</strong>`});
  prodRows.push({label:'Logo personnalisé', val: S.perso?'✅ Oui':'Non'});
  prodRows.push({label:'Prix unitaire HT', val:`<strong>${up.toFixed(2)} €</strong>`});
  prodRows.push({label:'Sous-total protections', val:`<strong>${(up*q).toFixed(2)} €</strong>`});

  // ── Options sur le produit principal ──
  const options = [];
  if(S.customColor) options.push({ref:'OPT-COLOR', label:'Couleur sur mesure', qty:q, pu:0.10, total:(q*0.10).toFixed(2)+' €'});
  if(S.multiColor)  options.push({ref:'OPT-MULTI', label:'Impression 2 couleurs+', qty:q, pu:0.05, total:(q*0.05).toFixed(2)+' €'});
  if(S.designer)    options.push({ref:'OPT-DESIGN', label:'Designer logo protections — Offert', qty:1, pu:0, total:'OFFERT'});
  // Designer collier supprimé

  // ── Autres produits ──
  const autresProduits = [];
  // Collier perso supprimé
  if(S.extras.collier&&S.extras.qtyCollier&&!S.collierPerso){
    const puC=getCollierBasePrice(S.extras.qtyCollier);
    autresProduits.push({ref:'SC-COLLIER', label:'Collier Porte-gobelet', qty:S.extras.qtyCollier, pu:puC, total:(S.extras.qtyCollier*puC).toFixed(2)+' €'});
  }
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){
    const puP=getPaillesCartonPrice(S.extras.qtyPaillesCarton);
    autresProduits.push({ref:'PAILLE-CARTON', label:'Pailles Carton Noires', qty:S.extras.qtyPaillesCarton, pu:puP, total:(S.extras.qtyPaillesCarton*puP).toFixed(2)+' €'});
  }
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){
    const puI=getPaillesInoxPrice(S.extras.qtyPaillesInox);
    autresProduits.push({ref:'PAILLE-INOX', label:'Pailles Inox Réutilisables', qty:S.extras.qtyPaillesInox, pu:puI, total:(S.extras.qtyPaillesInox*puI).toFixed(2)+' €'});
  }
  ['comptoir','tournant','distributeur'].forEach(k=>{
    if(S.extras[k]){
      const qPr=S.extras['qty'+k.charAt(0).toUpperCase()+k.slice(1)]||1;
      autresProduits.push({ref:'PRES-'+k.toUpperCase().slice(0,3), label:'Présentoir '+k.charAt(0).toUpperCase()+k.slice(1), qty:qPr, pu:25, total:(qPr*25).toFixed(2)+' €'});
    }
  });

  // ── Cadeaux offerts ──
  const cadeaux = [];
  if(S.extras.cadeau_kitCom) cadeaux.push({ref:'KIT-RS', label:'Kit Communication Réseaux Sociaux'});
  if(S.extras.cadeau_presentoir) cadeaux.push({ref:'PRES-CADEAU', label:'Présentoir '+(S.extras.presentoirChoisi||'Distributeur')});
  if(S.extras.cadeau_colliers) cadeaux.push({ref:'COL-CADEAU', label:'50 Colliers Porte-gobelet'});

  // ── Fichiers ──
  const logoLink = S.logoCloudUrl
    ? `<div style="margin-top:6px"><img src="${S.logoCloudUrl}" style="max-height:80px;max-width:200px;border-radius:6px;border:1px solid #eee;background:#f9f9f9;padding:4px" alt="Logo protections"><br><a href="${S.logoCloudUrl}" style="color:#00a064;font-size:12px">⬇ Télécharger l'original</a></div>`
    : (S.logoImg ? '<em style="color:#999">Upload en cours...</em>' : '—');
  const collierLogoLink = S.collierCloudUrl
    ? `<div style="margin-top:6px"><img src="${S.collierCloudUrl}" style="max-height:80px;max-width:200px;border-radius:6px;border:1px solid #eee;background:#f9f9f9;padding:4px" alt="Logo collier"><br><a href="${S.collierCloudUrl}" style="color:#00a064;font-size:12px">⬇ Télécharger l'original</a></div>`
    : (S.collierLogo ? '<em style="color:#999">Upload en cours...</em>' : '—');
  const briefMain = S.designerFilesMainUrls?.length ? S.designerFilesMainUrls.map(f=>`<a href="${f.url}" style="color:#00a064">⬇ ${f.name}</a>`).join('<br>') : '—';
  const briefCol = S.designerFilesCollierUrls?.length ? S.designerFilesCollierUrls.map(f=>`<a href="${f.url}" style="color:#00a064">⬇ ${f.name}</a>`).join('<br>') : '—';

  // ── Helpers HTML ──
  const row = (label, val) => `<tr><td style="padding:6px 12px 6px 0;color:#666;vertical-align:top;white-space:nowrap;width:42%">${label}</td><td style="padding:6px 0;vertical-align:top">${val}</td></tr>`;
  const section = (title, icon) => `<h3 style="margin:24px 0 10px;color:#1a1a2e;font-size:15px;border-bottom:3px solid #f2be1a;padding-bottom:7px">${icon} ${title}</h3>`;

  return `<div style="font-family:Arial,sans-serif;font-size:14px;color:#222;max-width:640px;margin:0 auto">

  <!-- HEADER -->
  <div style="background:#1a1a2e;padding:20px 24px;border-radius:10px 10px 0 0">
    <table style="width:100%"><tr>
      <td><h2 style="margin:0;color:#fff;font-size:20px">🧾 Nouvelle commande B2B</h2>
          <p style="margin:4px 0 0;color:#f2be1a;font-size:13px;font-weight:bold">MY SAFE CUP</p></td>
      <td style="text-align:right;vertical-align:top">
        <span style="background:#f2be1a;color:#1a1a2e;padding:4px 10px;border-radius:6px;font-weight:bold;font-size:13px">${ref}</span><br>
        <span style="color:rgba(255,255,255,.6);font-size:12px;margin-top:4px;display:block">${new Date().toLocaleDateString('fr-FR')}</span>
      </td>
    </tr></table>
  </div>

  <!-- BODY -->
  <div style="border:1px solid #e5e5e5;border-top:none;padding:24px;border-radius:0 0 10px 10px;background:#fff">

  ${contactBlock}

  ${section('Produit principal', '📦')}
  <table style="width:100%;border-collapse:collapse;font-size:14px">${prodRows.map(r=>row(r.label,r.val)).join('')}</table>

  ${autresProduits.length ? `
  ${section('Autres produits', '📦')}
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    <tr style="background:#f5f5f5">
      <th style="padding:7px 8px;text-align:left;font-size:12px;color:#666;font-weight:600">Réf</th>
      <th style="padding:7px 8px;text-align:left;font-size:12px;color:#666;font-weight:600">Produit</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">Qté</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">PU HT</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">Total HT</th>
    </tr>
    ${autresProduits.map((o,i)=>`<tr style="background:${i%2===0?'#fff':'#fafafa'}">
      <td style="padding:7px 8px;font-size:11px;color:#999;white-space:nowrap">${o.ref||'—'}</td>
      <td style="padding:7px 8px">${o.label}</td>
      <td style="padding:7px 8px;text-align:right">${o.qty}</td>
      <td style="padding:7px 8px;text-align:right">${o.pu.toFixed(2)} €</td>
      <td style="padding:7px 8px;text-align:right;font-weight:bold">${o.total}</td>
    </tr>`).join('')}
  </table>` : ''}

  ${options.length ? `
  ${section('Options', '⚙️')}
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    <tr style="background:#f5f5f5">
      <th style="padding:7px 8px;text-align:left;font-size:12px;color:#666;font-weight:600">Réf</th>
      <th style="padding:7px 8px;text-align:left;font-size:12px;color:#666;font-weight:600">Option</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">Qté</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">PU HT</th>
      <th style="padding:7px 8px;text-align:right;font-size:12px;color:#666;font-weight:600">Total HT</th>
    </tr>
    ${options.map((o,i)=>`<tr style="background:${i%2===0?'#fff':'#fafafa'}">
      <td style="padding:7px 8px;font-size:11px;color:#999;white-space:nowrap">${o.ref||'—'}</td>
      <td style="padding:7px 8px">${o.label}</td>
      <td style="padding:7px 8px;text-align:right">${o.qty}</td>
      <td style="padding:7px 8px;text-align:right">${o.pu.toFixed(2)} €</td>
      <td style="padding:7px 8px;text-align:right;font-weight:bold">${o.total}</td>
    </tr>`).join('')}
  </table>` : ''}

  ${cadeaux.length ? `
  ${section('Cadeaux offerts 🎁', '')}
  ${cadeaux.map(c=>`<div style="display:flex;align-items:center;gap:8px;padding:5px 0">
    <span style="background:#d4edda;color:#155724;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:bold">OFFERT</span>
    <span style="font-size:11px;color:#999">${c.ref}</span>
    <span>${c.label}</span>
  </div>`).join('')}` : ''}

  ${section('Totaux', '💰')}
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    ${row('Total HT', `<strong style="font-size:16px">${totalHT} €</strong>`)}
    ${row('Total TTC (20%)', `<strong style="font-size:16px">${totalTTC} €</strong>`)}
    ${row('Destination', S.destination)}
    ${row('Délai estimé', S.perso?'15 à 20 jours ouvrés':'2 à 3 jours ouvrés')}
    ${S.promo ? row('Code promo', `<span style="background:#fff3cd;padding:2px 8px;border-radius:4px">${S.promo} (-${(S.promoDisc*100).toFixed(0)}%)</span>`) : ''}
  </table>

  ${section('Fichiers & Visuels', '🎨')}
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    ${row('Logo protections', logoLink)}
    ${row('Instructions protections', briefMain)}
    ${S.designerNote ? row('Instructions designer protections', `<em>${S.designerNote}</em>`) : ''}
    ${S.product === 'biberon' ? row('Packaging biberon', S.packaging === 'kraft'
      ? '<strong>Packaging Jetable Papier Kraft</strong> — logo sur packaging'
      : '<strong>Packaging PVC Réutilisable</strong> — éco-responsable') : ''}
  </table>

  </div>

  <!-- FOOTER -->
  <div style="text-align:center;padding:12px;color:#999;font-size:11px;margin-top:8px">
    My Safe Cup — 386 Quai Marcel Pagnol, 83000 Toulon — contact@mysafecup.co
  </div>
</div>`;
}

// ══════════════════════════════════════════
// BUILD MESSAGE COMMANDE
// ══════════════════════════════════════════
function buildOrderMessage(contact, total){
  const {pre, nom, soc, mail, tel, date, type, msg} = contact;
  const totalTTC = (S.destination==='Outre-Mer'?total:total*1.20);

  const contactBlock = `
  <h3 style="margin:0 0 10px;color:#1a1a2e;font-size:15px;border-bottom:3px solid #f2be1a;padding-bottom:7px">👤 Contact client</h3>
  <table style="width:100%;border-collapse:collapse;font-size:14px">
    <tr><td style="padding:5px 0;color:#666;width:42%">Nom</td><td><strong>${pre} ${nom}</strong></td></tr>
    <tr><td style="padding:5px 0;color:#666">Société</td><td>${soc||'—'}</td></tr>
    <tr><td style="padding:5px 0;color:#666">Email</td><td><a href="mailto:${mail}">${mail}</a></td></tr>
    <tr><td style="padding:5px 0;color:#666">Téléphone</td><td>${tel||'—'}</td></tr>
    <tr><td style="padding:5px 0;color:#666">Date événement</td><td>${date||'Non précisée'}</td></tr>
    <tr><td style="padding:5px 0;color:#666">Type événement</td><td>${type||'Non précisé'}</td></tr>
    ${msg?`<tr><td style="padding:5px 0;color:#666">Message</td><td><em>${msg}</em></td></tr>`:''}
  </table>`;

  return buildEmailHTML('MSC-'+new Date().getFullYear()+'-'+Date.now().toString().slice(-5), total.toFixed(2), totalTTC.toFixed(2), [], contactBlock);
}

function validateField(id, fieldId, checkFn){
  const el=document.getElementById(id);
  const ff=document.getElementById(fieldId);
  const ok=checkFn(el.value.trim());
  ff.classList.toggle('error',!ok);
  return ok;
}

async function submitOrder(){
  // Désormais géré par submitOrderModal — cette fonction est un alias
  const contact = S.contactInfo;
  if(!contact) return;
  const up=getUnitPrice(),q=S.qty;
  const designerCost=(0)+(0);
  const multiColorCost=S.multiColor?q*0.05:0;
  const customColorCost=S.customColor?q*0.10:0;
  const collierPersoCost=0; // Perso collier supprimée
  let extrasCost=0;
  if(S.extras.paillesCarton&&S.extras.qtyPaillesCarton){const puP=getPaillesCartonPrice(S.extras.qtyPaillesCarton);extrasCost+=S.extras.qtyPaillesCarton*puP;}
  if(S.extras.paillesInox&&S.extras.qtyPaillesInox){const puI=getPaillesInoxPrice(S.extras.qtyPaillesInox);extrasCost+=S.extras.qtyPaillesInox*puI;}
  ['comptoir','tournant','distributeur'].forEach(k=>{if(S.extras[k]){const qPr=S.extras['qty'+k.charAt(0).toUpperCase()+k.slice(1)]||1;extrasCost+=qPr*25;}});
  const subtotal=up*q+customColorCost+multiColorCost+designerCost+collierPersoCost+extrasCost;
  const disc=S.promoDisc?subtotal*S.promoDisc:0;
  const total=subtotal-disc;
  const commande_ref=getCommandeRef();
  const message=buildOrderMessage(contact,total);
  try{
    const subject = `[MSC B2B] Commande — ${commande_ref} — ${contact.soc}`;
    await sendBrevoEmail(subject, message);
  }catch(err){
    console.error('Brevo submitOrder:',err);
  }
}

// ══════════════════════════════════════════
// TOAST
// ══════════════════════════════════════════
function toast(icon,msg){
  const t=document.getElementById('toast');
  document.getElementById('ti').textContent=icon;
  document.getElementById('tm').textContent=msg;
  t.classList.add('show');
  clearTimeout(t._t);
  t._t=setTimeout(()=>t.classList.remove('show'),3200);
}

// ── Init — preload logos ──
(function(){
  loadImgBlob(LOGO_ROND, img=>{ window._logoRondImg=img; draw(); });
  loadImgBlob(LOGO_LONG, img=>{ window._logoLongImg=img; });
  loadImgBlob(LOGO_MAIN, img=>{ window._logoMainImg=img; });
  loadImgBlob(LOGO_OF,   img=>{ window._logoOfImg=img; });

  // Preload real product photos
  if(PRODUCT_IMAGES.chouchou){
    loadImgBlob(PRODUCT_IMAGES.chouchou, img=>{
      window._chouchouImg=img;
      setTimeout(()=>drawThumb('chouchou'),50);
      if(S.product==='chouchou') draw();
    });
  }
  if(PRODUCT_IMAGES.portecles){
    loadImgBlob(PRODUCT_IMAGES.portecles, img=>{
      window._porteclesImg=img;
      setTimeout(()=>drawThumb('portecles'),50);
      if(S.product==='portecles') draw();
    });
  }
  if(PRODUCT_IMAGES.biberon){
    loadImgBlob(PRODUCT_IMAGES.biberon, img=>{
      window._biberonImg=img;
      setTimeout(()=>drawThumb('biberon'),0);
      if(S.product==='biberon') draw();
    });
  }
})();

draw();
updQtyHint();
updateTiers();
updateGif();
renderSwatches();
updatePackagingVisibility();
updatePrevLabel();
// Pre-set destination
S.destination = 'France';
// Redraw all thumbs after DOM is fully ready
setTimeout(()=>['biberon','portecles','chouchou'].forEach(drawThumb), 100);